<main>
  <!-- <a id="btnCnsltNav" class="nav-link text-white d-none" routerLinkActive="active" [routerLink]="['/home/consultation']"
    (click)="changeMenu()">Doctor Consultation</a> -->
  <div id="slide-panel">
    <a id="opener"><img src="../../../assets/images/side_btn.png" /></a>
    <div>
      <nav>
        <a id="btnCnsltNav" class="nav-link text-white" routerLinkActive="active" 
          (click)="changeMenu()">Doctor Consultation</a>
        <a class="nav-link text-white" routerLinkActive="active" 
          (click)="changeMenu()">Appointment Schedule</a>
        <a class="nav-link text-white" routerLinkActive="active" 
          (click)="changeMenu()"> Payment Status</a>
        <a class="nav-link text-white" routerLinkActive="active"
          (click)="changeMenu()">Support</a>
      </nav>
    </div>
  </div>

  <div class="container-fluid" style="margin-top:10rem !important;">
    <button type="button" style="display: none;" id="pocforopen" (click)="showHideVideo2()"></button>
  <button type="button" style="display: none;" id="navigatepoc" (click)="navigatepocclick()"></button>
  <button type="button" style="display: none;" id="docDiscconectCall" (click)="docSkipCallclick()"></button>
  <button type="button" style="display: none;" id="navigatepocispocgiven" (click)="navigatepocIsPocGivenTrueclick()"></button>
    <div class="row ">
      <div class="col-xl-7 pl-3 pl-xl-0">
        <!-- class="sticky-sidebar " -->

        <ng-container *ngIf="is_self">
          <div class=" mb-0 border-0 ">
            <div class="row no-gutters">
              <!-- <div class="col-md-2 text-center">
                  <img src="../../../assets/images/image-1.png" class="image-fluid" alt="...">
                </div> -->
              <div class="col-xl-12  pl-md-4 pl-xl-0">
                <div class="user-details">
                  <h2  style="font-weight:bold">Patient Information</h2>
                  <div class="mb-2">
                    <span class="card-title mr-2">
                      <span>
                        {{benData?.first_name | uppercase }} {{benData?.middle_name | uppercase }}
                        {{benData?.last_name | uppercase }}

                      </span>
                      <span> (RegId: {{benId}})</span>&nbsp;
                    </span>
                    <span class="small-font"> {{benData?.age}} ({{getGender(benData?.gender_id)}})</span>
                    &nbsp;<span class="ph">Ph:</span>
                    <span class="small-font">
                      {{benData?.member_mobile==null?benData?.mobile:benData.member_mobile}}</span>
                      &nbsp;&nbsp;&nbsp;&nbsp;<span  class="ph" *ngIf="enableInsuranceDetailsInPoc">Status :</span><span *ngIf="enableInsuranceDetailsInPoc"> {{benData?.insurance_plan_details?.statusName}}</span>

                    <!-- <span class="small">
                      Address : {{benData?.address}}
                      </span> -->   
                  </div>
                  <div class="row" *ngIf="enableInsuranceDetailsInPoc">
                    <div class="col-sm-4">
                      <span  class="ph">Emp Id :</span><span>{{benData?.employee_id}}</span> 
                    </div>
                    <div class="col-sm-4">
                      <span  class="ph">Aadhaar No :</span><span>{{benData?.national_identifier_no}}</span>

                    </div>
                    <div class="col-sm-4">
                      <span  class="ph">Insurance Id :</span><span> {{benData?.insurance_number}}</span>

                    </div>
                  </div>
                  <div class="row" *ngIf="enableInsuranceDetailsInPoc">
                   <div class="col-sm-12 mr-2">
                      <span  class="ph">Insurance Name :</span> <span>{{benData?.insurance_plan_details?.insurerName}}</span>
                      </div> 
                      <div class="col-sm-12 mr-2" *ngIf="enableInsuranceDetailsInPoc">
                        <span  class="ph">Corporate Name :</span> <span>{{benData?.insurance_plan_details?.corporateName}}</span>
                        </div>
                        <div class="col-sm-12 mr-2">
                          <span  class="ph">TPA Name :</span><span> {{benData?.insurance_plan_details?.tpaName}}</span> 
                          </div>
                        </div>
                    <div class="row" *ngIf="enableInsuranceDetailsInPoc">
                        <div class="col-sm-12 mr-2">
                          <span  class="ph">Plan Name :</span><span> {{benData?.insurance_plan_details?.plan_name}}</span> 
                        </div> 
                       </div>
                      </div>
                  <div class="row">

                    <!-- <div class="col-xl-12 mb-2"><span> Address: {{benData?.address}} </span></div>
                      <div class="col-xl-6 mb-2"><span>ABHA Address</span>:<span *ngIf="healthidaddress=='null'">
                        </span><span *ngIf="healthidaddress!='null'"> {{healthidaddress}}</span></div>
                      <div class="col-xl-6 mb-2"><span>ABHA Number</span>:<span *ngIf="healthidnumber=='null'">
                        </span><span *ngIf="healthidnumber!='null'"> {{healthidnumber}}</span></div> -->
                    <div class="col-xl-12" *ngIf="symptoms"><span class="card-text mr-0">Symptoms : </span><span
                        class="">{{(symptoms||'')}}</span></div>

                  </div>
                  <!-- <div class="col-xl-6" *ngIf="healthidnumber"><span>
                    <b> ABHA Number:</b>
                   </span>:<span *ngIf="healthidnumber=='null'">
                  </span><span *ngIf="healthidnumber!='null'"> {{healthidnumber}}</span></div> -->
                </div>
              
            </div>
          </div>

          <div class="row ml-2 mb-2 mt-2">
            <ng-container>
              <div class="form-check  col-md-2">
                <input class="form-check-input" type="radio" name="consultationType" [(ngModel)]="consType"
                  [ngModelOptions]="{standalone: true}" value="New">
                <label class="form-check-label DP" for="inlineRadio1">New </label>
              </div>
              <div class="form-check col-md-2">
                <input type="radio" class="form-check-input" name="consultationType" [(ngModel)]="consType"
                  [ngModelOptions]="{standalone: true}" value="Follow Up" data-toggle="modal"
                  data-target="#patientModal">
                <label class="form-check-label DP" for="inlineRadio2">Follow up </label>
              </div>
               <div class="col-md-4" *ngIf="isPregnancy">
                <label class="label">Visit Type :</label>             
                <select class="form-control form-control-sm" [(ngModel)]="visitedType" [ngModelOptions]="{standalone: true}" (change)="onClear($event.target.value)">
                  <option value=null>Select</option>
                  <option *ngFor="let opt of visitTypeList" [value]="opt.id">{{ opt.visit_type }}</option>

                </select>
              </div>
            </ng-container>
            <!-- <div class="form-group  col-md-3 d-none">
              <div>
                <input  type="checkbox"  (change)="onEpaperChng($event.target.checked)"
                  style="width: 20px; height:20px;">
                <label class="form-check-label DP"  style="font-size: 20px; ">
                  Digital Prescription
                </label>
              </div>
            </div> -->
            <div class="form-group  col-md-3" *ngIf="!isOffLinePOC()">
              <div class="d-flex">
                <label for="switch" class="font-weight-bold mr-2">Show Video</label>
                <div class="switchToggle">
                  <input type="checkbox" checked id="switch" (click)="showHideVideo()">
                  <label for="switch"></label>
                </div>
              </div>

            </div>
          </div>
          <div class="form-group">
              <div class="form-check">
                <input type="checkbox" id="cb1"
                  (change)="onEpaperChng($event.target.checked)">
                <label class="form-check-label DP" for="cb1" style="font-size: 20px;">
                  Digital Prescription
                </label>
              </div>
            </div>


        </ng-container>

        <ng-container *ngIf="!is_self">
          <!-- <div class="mb-3 border-0">
            <div class="row no-gutters">
              <div class="col-md-10 pl-xl-0">
                <div class="card-body pt-1 user-details pt-4 pt-md-0 pl-0 pr-0 pl-md-4 pr-md-4 pb-0">
                  <div class="mb-2"><span class="card-title mr-2">
                      {{depDtls?.first_name?.toUpperCase() + ' ' + depDtls?.last_name?.toUpperCase()}}
                      {{depId}}</span><span>{{depDtls?.age}} {{getGender(depDtls?.gender_id)}}</span></div>
                  <div class="row">
                    <div class="col-xl-12 col-md-6 mb-2"><span>Ph: {{depDtls?.member_mobile == null ? depDtls?.mobile
                        : depDtls?.member_mobile}}</span></div>
                    <div class="col-xl-12 mb-2"><span> Address: {{depDtls?.address}} </span></div>
            
                    <div class="col-xl-12"><span class="card-text mr-0">Symptoms : </span><span
                        class="">{{(symptoms||'')}}</span></div>
                  </div>

                </div>
              </div>
            </div>
          </div> -->
          <div class=" mb-0 border-0">
            <div class="row no-gutters">
              <!-- <div class="col-md-2 text-center">
                  <img src="../../../assets/images/image-1.png" class="image-fluid" alt="...">
                </div> -->
              <div class="col-md-12  pl-md-4 pl-xl-0">
                <div class="user-details">
                  <h2  style="font-weight:bold">Member Information</h2>
                  <div class="mb-2">
                    <span class="card-title mr-2">
                      <span>
                        {{depDtls?.first_name?.toUpperCase() + ' ' + depDtls?.last_name?.toUpperCase()}}

                      </span>
                      <span> (RegId: {{depId}})</span>&nbsp;
                    </span>
                    <span class="small-font"> {{depDtls?.age}} ({{getGender(depDtls?.gender_id)}})</span>
                    &nbsp; <span class="ph">Ph:</span>
                    <span class="small-font">
                      {{depDtls?.member_mobile == null ? depDtls?.mobile : depDtls?.member_mobile}}</span>
                      &nbsp;&nbsp;&nbsp;&nbsp; <span  class="ph" *ngIf="enableInsuranceDetailsInPoc">Status :</span><span> {{benData?.insurance_plan_details?.statusName}}</span>
                  </div>
                  <div class="row" *ngIf="enableInsuranceDetailsInPoc">
                    <div class="col-sm-4">
                      <span  class="ph">Emp Id :</span><span>{{benData?.employee_id}}</span> 
                    </div>
                    <div class="col-sm-4">
                      <span  class="ph">Aadhaar No :</span><span>{{benData?.national_identifier_no}}</span>

                    </div>
                    <div class="col-sm-4">
                      <span  class="ph">Insurance Id :</span><span> {{benData?.insurance_number}}</span>

                    </div>
                  </div>
                  <div class="row" *ngIf="enableInsuranceDetailsInPoc">
                     <div class="col-sm-12 mr-2">
                       <span  class="ph">Insurance Name :</span> <span>{{benData?.insurance_plan_details?.insurerName}}</span>
                       </div> 
                       <div class="col-sm-12 mr-2" *ngIf="enableInsuranceDetailsInPoc">
                         <span  class="ph">Corporate Name :</span> <span>{{benData?.insurance_plan_details?.corporateName}}</span>
                         </div>
                         <div class="col-sm-12 mr-2">
                           <span  class="ph">TPA Name :</span><span> {{benData?.insurance_plan_details?.tpaName}}</span> 
                           </div>
                      </div>
                         <div class="row" *ngIf="enableInsuranceDetailsInPoc">
                          <div class="col-sm-12 mr-2">
                            <span  class="ph">Plan Name :</span><span> {{benData?.insurance_plan_details?.plan_name}}</span> 
                          </div> 
                         </div>
                        </div>
                  <!-- &nbsp;  &nbsp;  <span *ngIf="enableInsuranceDetailsInPoc">
                    <span class="ph">Emp Id :</span><span>{{benData?.employee_id}}</span> &nbsp;&nbsp;  
                    <span  class="ph">Aadhaar No :</span><span>{{benData?.national_identifier_no}}</span>
                    &nbsp; <br> <span  class="ph">Insurance Id :</span><span> {{benData?.insurance_number}}</span> &nbsp; &nbsp; 
                    <span  class="ph">Insurance Name :</span> <span>{{benData?.insurance_plan_details?.insurerName}}</span> &nbsp; &nbsp; 
                    <span class="ph">Corporate Name :</span> <span>{{benData?.insurance_plan_details?.corporateName}}</span>
                   <br> <span  class="ph">TPA Name :</span><span> {{benData?.insurance_plan_details?.tpaName}}</span> &nbsp; &nbsp; 
                   <span  class="ph">Plan Name :</span> <span> {{benData?.insurance_plan_details?.plan_name}}</span> &nbsp; &nbsp; 
                   
                  </span> -->
                  <div class="row">

                    <!-- <div class="col-xl-12 mb-2"><span> Address: {{benData?.address}} </span></div>
                      <div class="col-xl-6 mb-2"><span>ABHA Address</span>:<span *ngIf="healthidaddress=='null'">
                        </span><span *ngIf="healthidaddress!='null'"> {{healthidaddress}}</span></div>
                      <div class="col-xl-6 mb-2"><span>ABHA Number</span>:<span *ngIf="healthidnumber=='null'">
                        </span><span *ngIf="healthidnumber!='null'"> {{healthidnumber}}</span></div> -->
                    <div class="col-xl-12" *ngIf="symptoms"><span class="card-text mr-0">Symptoms : </span><span
                        class="">{{(symptoms||'')}}</span></div>

                  </div>
                  <!-- <div class="col-xl-6" *ngIf="healthidnumber"><span>
                    <b> ABHA Number:</b>
                   </span>:<span *ngIf="healthidnumber=='null'">
                  </span><span *ngIf="healthidnumber!='null'"> {{healthidnumber}}</span></div> -->
              
              </div>
            </div>
          </div>

          <div class="row mb-0 pb-0">
            <div class=" consultant col-xl-7 col-md-6 mb-0 pt-2" *ngIf="isukt">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="consultationType" [(ngModel)]="consType"
                  [ngModelOptions]="{standalone: true}" value="New">
                <label class="form-check-label" for="inlineRadio1">New </label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" name="consultationType" [(ngModel)]="consType"
                  [ngModelOptions]="{standalone: true}" value="Follow Up" data-toggle="modal"
                  data-target="#patientModal">
                <label class="form-check-label" for="inlineRadio2">Follow up </label>
              </div>
            </div>

            <!-- <div class="form-group" *ngIf="isShowDP">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="cb1" (change)="onEpaperChng($event.target.checked)"
                  style="width: 20px; height:20px;">
                <label class="form-check-label DP" for="cb1" style="font-size: 20px;">
                  Digital Prescription
                </label>
              </div>
            </div> -->

          </div>
          <div class="container-fluid pl-0 pr-0">
          <div class="row ml-2 mb-0 mt-0">
            <ng-container>
              <div class="form-check  col-md-2">
                <input class="form-check-input" type="radio" name="consultationType" [(ngModel)]="consType"
                  [ngModelOptions]="{standalone: true}" value="New">
                <label class="form-check-label" for="inlineRadio1">New </label>
              </div>
                  <div class="col-md-4 mb-2" *ngIf="isPregnancy">
                <label class="label">Visit Type :</label>             
                <select class="form-control form-control-sm" [(ngModel)]="visitedType" [ngModelOptions]="{standalone: true}" (change)="onClear($event.target.value)">
                  <option value=null>Select</option>
                  <option *ngFor="let opt of visitTypeList" [value]="opt.id">{{ opt.visit_type }}</option>

                </select>
              </div>
            <div class="form-group  col-md-3 ml-0 mr-0 pl-0 pr-0">
              <div>
                <input  type="checkbox"  (change)="onEpaperChng($event.target.checked)"
                  style="width: 20px; height:20px;">
                <label class="form-check-label DP"  style="font-size: 20px;">
                  Digital Prescription
                </label>
              </div>
            </div>
 
            </ng-container>
            <!-- <div class="form-group  col-md-3 ml-0 mr-0 pl-0 pr-0">
              <div>
                <input  type="checkbox"  (change)="onEpaperChng($event.target.checked)"
                  style="width: 20px; height:20px;">
                <label class="form-check-label DP"  style="font-size: 20px;">
                  Digital Prescription
                </label>
              </div>
            </div> -->
            <div class="form-group  col-md-3" *ngIf="!isOffLinePOC()">
              <div class="d-flex">
                <label for="switch" class="font-weight-bold mr-2">Show Video</label>
                <div class="switchToggle">
                  <input type="checkbox" checked id="switch" (click)="showHideVideo()">
                  <label for="switch"></label>
                </div>
              </div>

            </div>
             
          </div>
        </div>
        </ng-container>

       


      </div>

      <div class="col-xl-5" style="display: flex; justify-content: end; align-items: end;">
        <div class="">
          <aside class="sticky-sidebar">
            <!-- SELF -->
            <ng-container *ngIf="is_self || !is_self">
              <ul class="list-inline mb-0">
                <li class="list-inline-item">
                  <button type="button" class="btn btn-sm btn-primary font-weight-bold mb-2" data-toggle="modal"
                    data-target="#emergencyModal" (click)="emergencyComment=''">
                    <!-- <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4 17V15H5.6L7.575 8.425C7.70833 7.99167 7.954 7.64567 8.312 7.387C8.67067 7.129 9.06667 7 9.5 7H12.5C12.9333 7 13.3293 7.129 13.688 7.387C14.046 7.64567 14.2917 7.99167 14.425 8.425L16.4 15H18V17H4ZM7.7 15H14.3L12.5 9H9.5L7.7 15ZM10 5V0H12V5H10ZM15.95 7.475L14.525 6.05L18.075 2.525L19.475 3.925L15.95 7.475ZM17 12V10H22V12H17ZM6.05 7.475L2.525 3.925L3.925 2.525L7.475 6.05L6.05 7.475ZM0 12V10H5V12H0Z"
                        fill="white" />
                    </svg> -->
                    Emergency
                  </button>
                </li>
                <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    (click)="openViewFileModal('ViewFiles')">
                    <!-- <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21.257 10.962C21.731 11.582 21.731 12.419 21.257 13.038C19.764 14.987 16.182 19 12 19C7.81801 19 4.23601 14.987 2.74301 13.038C2.51239 12.7411 2.38721 12.3759 2.38721 12C2.38721 11.6241 2.51239 11.2589 2.74301 10.962C4.23601 9.013 7.81801 5 12 5C16.182 5 19.764 9.013 21.257 10.962V10.962Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg> -->
  
                    View Files
                  </button></li>

                  <li class="list-inline-item">
                    <button class="btn btn-sm btn-primary mb-2 font-weight-bold" type="button" (click)="openVitalFileModal()">
                       Vitals History
                    </button>
                  </li>
                <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    type="button" data-toggle="modal" data-target="#patientModal">
                    <!-- <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 8V13H17V11H14V8H12Z" fill="white" />
                      <path
                        d="M21.292 8.497C20.8409 7.42705 20.1861 6.45501 19.364 5.635C18.1196 4.39057 16.5377 3.5381 14.814 3.183C13.6176 2.93949 12.3844 2.93949 11.188 3.183C9.46267 3.53584 7.87947 4.389 6.636 5.636C5.81589 6.45689 5.16133 7.42786 4.708 8.496C4.23911 9.60461 3.99832 10.7963 4 12L4.001 12.025H2L5 16L8 12.025H6.001L6 12C5.99712 10.6054 6.41346 9.24207 7.195 8.087C7.69912 7.34169 8.34095 6.69952 9.086 6.195C9.84394 5.68441 10.6941 5.3264 11.589 5.141C13.4075 4.7671 15.3001 5.13063 16.8507 6.15167C18.4013 7.17271 19.483 8.7677 19.858 10.586C20.0466 11.5179 20.0466 12.4781 19.858 13.41C19.675 14.3056 19.3168 15.1563 18.804 15.913C18.554 16.284 18.267 16.633 17.95 16.949C17.3112 17.587 16.5558 18.0966 15.725 18.45C15.3018 18.6289 14.862 18.7655 14.412 18.858C13.4804 19.0465 12.5206 19.0465 11.589 18.858C10.6943 18.6746 9.84447 18.3168 9.088 17.805C8.71595 17.5536 8.36871 17.2673 8.051 16.95L6.637 18.364C7.47212 19.2003 8.46403 19.8636 9.5559 20.3159C10.6478 20.7682 11.8181 21.0007 13 21C14.2031 20.9995 15.3939 20.7592 16.503 20.293C18.1106 19.6128 19.486 18.4803 20.462 17.033C21.4665 15.5469 22.0022 13.7937 22 12C22.0025 10.7966 21.7617 9.60502 21.292 8.497Z"
                        fill="white" />
                    </svg> -->
  
                    Patient History
                  </button></li>
                  <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    type="button" (click)="openLink()" *ngIf="EnableHIMSFileinPOC">
                    <!-- <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 8V13H17V11H14V8H12Z" fill="white" />
                      <path
                        d="M21.292 8.497C20.8409 7.42705 20.1861 6.45501 19.364 5.635C18.1196 4.39057 16.5377 3.5381 14.814 3.183C13.6176 2.93949 12.3844 2.93949 11.188 3.183C9.46267 3.53584 7.87947 4.389 6.636 5.636C5.81589 6.45689 5.16133 7.42786 4.708 8.496C4.23911 9.60461 3.99832 10.7963 4 12L4.001 12.025H2L5 16L8 12.025H6.001L6 12C5.99712 10.6054 6.41346 9.24207 7.195 8.087C7.69912 7.34169 8.34095 6.69952 9.086 6.195C9.84394 5.68441 10.6941 5.3264 11.589 5.141C13.4075 4.7671 15.3001 5.13063 16.8507 6.15167C18.4013 7.17271 19.483 8.7677 19.858 10.586C20.0466 11.5179 20.0466 12.4781 19.858 13.41C19.675 14.3056 19.3168 15.1563 18.804 15.913C18.554 16.284 18.267 16.633 17.95 16.949C17.3112 17.587 16.5558 18.0966 15.725 18.45C15.3018 18.6289 14.862 18.7655 14.412 18.858C13.4804 19.0465 12.5206 19.0465 11.589 18.858C10.6943 18.6746 9.84447 18.3168 9.088 17.805C8.71595 17.5536 8.36871 17.2673 8.051 16.95L6.637 18.364C7.47212 19.2003 8.46403 19.8636 9.5559 20.3159C10.6478 20.7682 11.8181 21.0007 13 21C14.2031 20.9995 15.3939 20.7592 16.503 20.293C18.1106 19.6128 19.486 18.4803 20.462 17.033C21.4665 15.5469 22.0022 13.7937 22 12C22.0025 10.7966 21.7617 9.60502 21.292 8.497Z"
                        fill="white" />
                    </svg> -->
  
                    HIMS Files
                  </button></li>
                  <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    type="button" (click)="openEyeModal()" *ngIf="EnableOptimetryDetailsInPOC">
                    Eye
                  </button></li>
                  <li class="list-inline-item" *ngIf="visitedType == '2'"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    type="button" (click)="openANCModal()" *ngIf="isPregnancy">
                    ANC
                  </button></li>
                  <li class="list-inline-item" *ngIf="visitedType == '5'"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    type="button" (click)="openDeliveryModal()" *ngIf="isPregnancy">
                    Delivery
                  </button></li>
                  <li class="list-inline-item" *ngIf="visitedType == '3'"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    type="button" (click)="openPNCModal()" *ngIf="isPregnancy">
                    PNC
                  </button></li>
                  <li class="list-inline-item" *ngIf="visitedType == '4'"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    type="button" (click)="openChildModal()" *ngIf="isPregnancy">
                    Child Care
                  </button></li>
                  <!-- <li class="list-inline-item" > <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    type="button" (click)="openncdModal()" *ngIf="isPregnancy">
                    Ncd q
                  </button></li> -->

                  <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    type="button"  (click)="openHRE()">
                    Health Risk Evaluation
                  </button></li>
                 

                <li class="list-inline-item"  *ngIf="isEnableCovid19"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    (click)="openModal()">
                    <!-- <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.75 3C5.02065 3 4.32118 3.28973 3.80546 3.80546C3.28973 4.32118 3 5.02065 3 5.75V18.25C3 18.9793 3.28973 19.6788 3.80546 20.1945C4.32118 20.7103 5.02065 21 5.75 21H18.25C18.9793 21 19.6788 20.7103 20.1945 20.1945C20.7103 19.6788 21 18.9793 21 18.25V5.75C21 5.02065 20.7103 4.32118 20.1945 3.80546C19.6788 3.28973 18.9793 3 18.25 3H5.75ZM4.5 5.75C4.5 5.06 5.06 4.5 5.75 4.5H18.25C18.94 4.5 19.5 5.06 19.5 5.75V18.25C19.5 18.94 18.94 19.5 18.25 19.5H5.75C5.06 19.5 4.5 18.94 4.5 18.25V5.75ZM7.5 10.75C7.5 10.5511 7.57902 10.3603 7.71967 10.2197C7.86032 10.079 8.05109 10 8.25 10C8.44891 10 8.63968 10.079 8.78033 10.2197C8.92098 10.3603 9 10.5511 9 10.75C9 10.9489 8.92098 11.1397 8.78033 11.2803C8.63968 11.421 8.44891 11.5 8.25 11.5C8.05109 11.5 7.86032 11.421 7.71967 11.2803C7.57902 11.1397 7.5 10.9489 7.5 10.75ZM8.25 8.5C7.65326 8.5 7.08097 8.73705 6.65901 9.15901C6.23705 9.58097 6 10.1533 6 10.75C6 11.3467 6.23705 11.919 6.65901 12.341C7.08097 12.7629 7.65326 13 8.25 13C8.84674 13 9.41903 12.7629 9.84099 12.341C10.2629 11.919 10.5 11.3467 10.5 10.75C10.5 10.1533 10.2629 9.58097 9.84099 9.15901C9.41903 8.73705 8.84674 8.5 8.25 8.5ZM8.25 15.5C8.05109 15.5 7.86032 15.579 7.71967 15.7197C7.57902 15.8603 7.5 16.0511 7.5 16.25C7.5 16.4489 7.57902 16.6397 7.71967 16.7803C7.86032 16.921 8.05109 17 8.25 17C8.44891 17 8.63968 16.921 8.78033 16.7803C8.92098 16.6397 9 16.4489 9 16.25C9 16.0511 8.92098 15.8603 8.78033 15.7197C8.63968 15.579 8.44891 15.5 8.25 15.5ZM6 16.25C6 15.9545 6.0582 15.6619 6.17127 15.389C6.28434 15.116 6.45008 14.8679 6.65901 14.659C6.86794 14.4501 7.11598 14.2843 7.38896 14.1713C7.66194 14.0582 7.95453 14 8.25 14C8.54547 14 8.83806 14.0582 9.11104 14.1713C9.38402 14.2843 9.63206 14.4501 9.84099 14.659C10.0499 14.8679 10.2157 15.116 10.3287 15.389C10.4418 15.6619 10.5 15.9545 10.5 16.25C10.5 16.8467 10.2629 17.419 9.84099 17.841C9.41903 18.2629 8.84674 18.5 8.25 18.5C7.65326 18.5 7.08097 18.2629 6.65901 17.841C6.23705 17.419 6 16.8467 6 16.25ZM12.25 10C12.0511 10 11.8603 10.079 11.7197 10.2197C11.579 10.3603 11.5 10.5511 11.5 10.75C11.5 10.9489 11.579 11.1397 11.7197 11.2803C11.8603 11.421 12.0511 11.5 12.25 11.5H17.25C17.4489 11.5 17.6397 11.421 17.7803 11.2803C17.921 11.1397 18 10.9489 18 10.75C18 10.5511 17.921 10.3603 17.7803 10.2197C17.6397 10.079 17.4489 10 17.25 10H12.25ZM11.5 16.25C11.5 16.0511 11.579 15.8603 11.7197 15.7197C11.8603 15.579 12.0511 15.5 12.25 15.5H17.25C17.4489 15.5 17.6397 15.579 17.7803 15.7197C17.921 15.8603 18 16.0511 18 16.25C18 16.4489 17.921 16.6397 17.7803 16.7803C17.6397 16.921 17.4489 17 17.25 17H12.25C12.0511 17 11.8603 16.921 11.7197 16.7803C11.579 16.6397 11.5 16.4489 11.5 16.25ZM6.75 6C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5H17.25C17.4489 7.5 17.6397 7.42098 17.7803 7.28033C17.921 7.13968 18 6.94891 18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H6.75Z"
                        fill="white" />
                    </svg> -->
  
                    Covid Form
                  </button></li>


                  <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    (click)="openViewFileModal('Insurance')" *ngIf="enableInsuranceDetailsInPoc">
                    <!-- <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21.257 10.962C21.731 11.582 21.731 12.419 21.257 13.038C19.764 14.987 16.182 19 12 19C7.81801 19 4.23601 14.987 2.74301 13.038C2.51239 12.7411 2.38721 12.3759 2.38721 12C2.38721 11.6241 2.51239 11.2589 2.74301 10.962C4.23601 9.013 7.81801 5 12 5C16.182 5 19.764 9.013 21.257 10.962V10.962Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg> -->
  
                    Insurance Files
                  </button></li>
                  <!-- commented below lines consult doctor 28-06-2022 -->
                    <li class="list-inline-item">
                      <button class="btn btn-sm btn-primary mb-2 font-weight-bold" type="button" (click)="openPatientModal()"
                        *ngIf="isOffLinePOC() == true">Consult Doctors
                      </button>
                    </li>
              
  
                <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    (click)="viewID()" *ngIf="isukt">
                    <!-- <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.75 3C5.02065 3 4.32118 3.28973 3.80546 3.80546C3.28973 4.32118 3 5.02065 3 5.75V18.25C3 18.9793 3.28973 19.6788 3.80546 20.1945C4.32118 20.7103 5.02065 21 5.75 21H18.25C18.9793 21 19.6788 20.7103 20.1945 20.1945C20.7103 19.6788 21 18.9793 21 18.25V5.75C21 5.02065 20.7103 4.32118 20.1945 3.80546C19.6788 3.28973 18.9793 3 18.25 3H5.75ZM4.5 5.75C4.5 5.06 5.06 4.5 5.75 4.5H18.25C18.94 4.5 19.5 5.06 19.5 5.75V18.25C19.5 18.94 18.94 19.5 18.25 19.5H5.75C5.06 19.5 4.5 18.94 4.5 18.25V5.75ZM7.5 10.75C7.5 10.5511 7.57902 10.3603 7.71967 10.2197C7.86032 10.079 8.05109 10 8.25 10C8.44891 10 8.63968 10.079 8.78033 10.2197C8.92098 10.3603 9 10.5511 9 10.75C9 10.9489 8.92098 11.1397 8.78033 11.2803C8.63968 11.421 8.44891 11.5 8.25 11.5C8.05109 11.5 7.86032 11.421 7.71967 11.2803C7.57902 11.1397 7.5 10.9489 7.5 10.75ZM8.25 8.5C7.65326 8.5 7.08097 8.73705 6.65901 9.15901C6.23705 9.58097 6 10.1533 6 10.75C6 11.3467 6.23705 11.919 6.65901 12.341C7.08097 12.7629 7.65326 13 8.25 13C8.84674 13 9.41903 12.7629 9.84099 12.341C10.2629 11.919 10.5 11.3467 10.5 10.75C10.5 10.1533 10.2629 9.58097 9.84099 9.15901C9.41903 8.73705 8.84674 8.5 8.25 8.5ZM8.25 15.5C8.05109 15.5 7.86032 15.579 7.71967 15.7197C7.57902 15.8603 7.5 16.0511 7.5 16.25C7.5 16.4489 7.57902 16.6397 7.71967 16.7803C7.86032 16.921 8.05109 17 8.25 17C8.44891 17 8.63968 16.921 8.78033 16.7803C8.92098 16.6397 9 16.4489 9 16.25C9 16.0511 8.92098 15.8603 8.78033 15.7197C8.63968 15.579 8.44891 15.5 8.25 15.5ZM6 16.25C6 15.9545 6.0582 15.6619 6.17127 15.389C6.28434 15.116 6.45008 14.8679 6.65901 14.659C6.86794 14.4501 7.11598 14.2843 7.38896 14.1713C7.66194 14.0582 7.95453 14 8.25 14C8.54547 14 8.83806 14.0582 9.11104 14.1713C9.38402 14.2843 9.63206 14.4501 9.84099 14.659C10.0499 14.8679 10.2157 15.116 10.3287 15.389C10.4418 15.6619 10.5 15.9545 10.5 16.25C10.5 16.8467 10.2629 17.419 9.84099 17.841C9.41903 18.2629 8.84674 18.5 8.25 18.5C7.65326 18.5 7.08097 18.2629 6.65901 17.841C6.23705 17.419 6 16.8467 6 16.25ZM12.25 10C12.0511 10 11.8603 10.079 11.7197 10.2197C11.579 10.3603 11.5 10.5511 11.5 10.75C11.5 10.9489 11.579 11.1397 11.7197 11.2803C11.8603 11.421 12.0511 11.5 12.25 11.5H17.25C17.4489 11.5 17.6397 11.421 17.7803 11.2803C17.921 11.1397 18 10.9489 18 10.75C18 10.5511 17.921 10.3603 17.7803 10.2197C17.6397 10.079 17.4489 10 17.25 10H12.25ZM11.5 16.25C11.5 16.0511 11.579 15.8603 11.7197 15.7197C11.8603 15.579 12.0511 15.5 12.25 15.5H17.25C17.4489 15.5 17.6397 15.579 17.7803 15.7197C17.921 15.8603 18 16.0511 18 16.25C18 16.4489 17.921 16.6397 17.7803 16.7803C17.6397 16.921 17.4489 17 17.25 17H12.25C12.0511 17 11.8603 16.921 11.7197 16.7803C11.579 16.6397 11.5 16.4489 11.5 16.25ZM6.75 6C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5H17.25C17.4489 7.5 17.6397 7.42098 17.7803 7.28033C17.921 7.13968 18 6.94891 18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H6.75Z"
                        fill="white" />
                    </svg> -->
  
                    ID Proof
                  </button></li>
                  <li class="list-inline-item"> <button type="button"  class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    (click)="audioConsent()"  *ngIf="isukt && !isOffLinePOC() && ( audio_file_path || audio_file_path3 || audio_file_path2)">
                    <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.75 3C5.02065 3 4.32118 3.28973 3.80546 3.80546C3.28973 4.32118 3 5.02065 3 5.75V18.25C3 18.9793 3.28973 19.6788 3.80546 20.1945C4.32118 20.7103 5.02065 21 5.75 21H18.25C18.9793 21 19.6788 20.7103 20.1945 20.1945C20.7103 19.6788 21 18.9793 21 18.25V5.75C21 5.02065 20.7103 4.32118 20.1945 3.80546C19.6788 3.28973 18.9793 3 18.25 3H5.75ZM4.5 5.75C4.5 5.06 5.06 4.5 5.75 4.5H18.25C18.94 4.5 19.5 5.06 19.5 5.75V18.25C19.5 18.94 18.94 19.5 18.25 19.5H5.75C5.06 19.5 4.5 18.94 4.5 18.25V5.75ZM7.5 10.75C7.5 10.5511 7.57902 10.3603 7.71967 10.2197C7.86032 10.079 8.05109 10 8.25 10C8.44891 10 8.63968 10.079 8.78033 10.2197C8.92098 10.3603 9 10.5511 9 10.75C9 10.9489 8.92098 11.1397 8.78033 11.2803C8.63968 11.421 8.44891 11.5 8.25 11.5C8.05109 11.5 7.86032 11.421 7.71967 11.2803C7.57902 11.1397 7.5 10.9489 7.5 10.75ZM8.25 8.5C7.65326 8.5 7.08097 8.73705 6.65901 9.15901C6.23705 9.58097 6 10.1533 6 10.75C6 11.3467 6.23705 11.919 6.65901 12.341C7.08097 12.7629 7.65326 13 8.25 13C8.84674 13 9.41903 12.7629 9.84099 12.341C10.2629 11.919 10.5 11.3467 10.5 10.75C10.5 10.1533 10.2629 9.58097 9.84099 9.15901C9.41903 8.73705 8.84674 8.5 8.25 8.5ZM8.25 15.5C8.05109 15.5 7.86032 15.579 7.71967 15.7197C7.57902 15.8603 7.5 16.0511 7.5 16.25C7.5 16.4489 7.57902 16.6397 7.71967 16.7803C7.86032 16.921 8.05109 17 8.25 17C8.44891 17 8.63968 16.921 8.78033 16.7803C8.92098 16.6397 9 16.4489 9 16.25C9 16.0511 8.92098 15.8603 8.78033 15.7197C8.63968 15.579 8.44891 15.5 8.25 15.5ZM6 16.25C6 15.9545 6.0582 15.6619 6.17127 15.389C6.28434 15.116 6.45008 14.8679 6.65901 14.659C6.86794 14.4501 7.11598 14.2843 7.38896 14.1713C7.66194 14.0582 7.95453 14 8.25 14C8.54547 14 8.83806 14.0582 9.11104 14.1713C9.38402 14.2843 9.63206 14.4501 9.84099 14.659C10.0499 14.8679 10.2157 15.116 10.3287 15.389C10.4418 15.6619 10.5 15.9545 10.5 16.25C10.5 16.8467 10.2629 17.419 9.84099 17.841C9.41903 18.2629 8.84674 18.5 8.25 18.5C7.65326 18.5 7.08097 18.2629 6.65901 17.841C6.23705 17.419 6 16.8467 6 16.25ZM12.25 10C12.0511 10 11.8603 10.079 11.7197 10.2197C11.579 10.3603 11.5 10.5511 11.5 10.75C11.5 10.9489 11.579 11.1397 11.7197 11.2803C11.8603 11.421 12.0511 11.5 12.25 11.5H17.25C17.4489 11.5 17.6397 11.421 17.7803 11.2803C17.921 11.1397 18 10.9489 18 10.75C18 10.5511 17.921 10.3603 17.7803 10.2197C17.6397 10.079 17.4489 10 17.25 10H12.25ZM11.5 16.25C11.5 16.0511 11.579 15.8603 11.7197 15.7197C11.8603 15.579 12.0511 15.5 12.25 15.5H17.25C17.4489 15.5 17.6397 15.579 17.7803 15.7197C17.921 15.8603 18 16.0511 18 16.25C18 16.4489 17.921 16.6397 17.7803 16.7803C17.6397 16.921 17.4489 17 17.25 17H12.25C12.0511 17 11.8603 16.921 11.7197 16.7803C11.579 16.6397 11.5 16.4489 11.5 16.25ZM6.75 6C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5H17.25C17.4489 7.5 17.6397 7.42098 17.7803 7.28033C17.921 7.13968 18 6.94891 18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H6.75Z"
                        fill="white" />
                    </svg>
  
                    Audio Consent
                  </button></li>
                  <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                    (click)="gotoEHR()" *ngIf="isEnableEHRinPOC">
                    EHR
                  </button></li>
                   <li class="list-inline-item" *ngIf="isEnableHeartBeatInPOC">
                    <button class="btn btn-sm btn-primary mb-2 font-weight-bold" (click)="dongleLink()">
                     Dongle Link
                    </button>
                  </li>
                  <li class="list-inline-item" *ngIf="isEnableHeartBeatInPOC">
                    <button class="btn btn-sm btn-primary mb-2 font-weight-bold" (click)="toggleHeartbeat()">
                      
                      Heartbeat 
                    </button>
                  </li>
                  <li class="list-inline-item" *ngIf="isEnableHeartBeatInPOC">
                    <button class="btn btn-sm btn-primary mb-2 font-weight-bold" data-toggle="modal" data-target="#heartbeatLink">
                      
                      send HeartBeat Link
                    </button>
                  </li>
                  <li class="list-inline-item" *ngIf="isEnableHeartBeatInPOC">
                    <button class="btn btn-sm btn-primary mb-2 font-weight-bold" (click)="getHeartbeatLink()">
                      
                      get HeartBeat Link
                    </button>
                  </li>
  
                <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-emg mb-2 font-weight-bold"
                    (click)="gotoConsultation()">
                    <!-- <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.75 3C5.02065 3 4.32118 3.28973 3.80546 3.80546C3.28973 4.32118 3 5.02065 3 5.75V18.25C3 18.9793 3.28973 19.6788 3.80546 20.1945C4.32118 20.7103 5.02065 21 5.75 21H18.25C18.9793 21 19.6788 20.7103 20.1945 20.1945C20.7103 19.6788 21 18.9793 21 18.25V5.75C21 5.02065 20.7103 4.32118 20.1945 3.80546C19.6788 3.28973 18.9793 3 18.25 3H5.75ZM4.5 5.75C4.5 5.06 5.06 4.5 5.75 4.5H18.25C18.94 4.5 19.5 5.06 19.5 5.75V18.25C19.5 18.94 18.94 19.5 18.25 19.5H5.75C5.06 19.5 4.5 18.94 4.5 18.25V5.75ZM7.5 10.75C7.5 10.5511 7.57902 10.3603 7.71967 10.2197C7.86032 10.079 8.05109 10 8.25 10C8.44891 10 8.63968 10.079 8.78033 10.2197C8.92098 10.3603 9 10.5511 9 10.75C9 10.9489 8.92098 11.1397 8.78033 11.2803C8.63968 11.421 8.44891 11.5 8.25 11.5C8.05109 11.5 7.86032 11.421 7.71967 11.2803C7.57902 11.1397 7.5 10.9489 7.5 10.75ZM8.25 8.5C7.65326 8.5 7.08097 8.73705 6.65901 9.15901C6.23705 9.58097 6 10.1533 6 10.75C6 11.3467 6.23705 11.919 6.65901 12.341C7.08097 12.7629 7.65326 13 8.25 13C8.84674 13 9.41903 12.7629 9.84099 12.341C10.2629 11.919 10.5 11.3467 10.5 10.75C10.5 10.1533 10.2629 9.58097 9.84099 9.15901C9.41903 8.73705 8.84674 8.5 8.25 8.5ZM8.25 15.5C8.05109 15.5 7.86032 15.579 7.71967 15.7197C7.57902 15.8603 7.5 16.0511 7.5 16.25C7.5 16.4489 7.57902 16.6397 7.71967 16.7803C7.86032 16.921 8.05109 17 8.25 17C8.44891 17 8.63968 16.921 8.78033 16.7803C8.92098 16.6397 9 16.4489 9 16.25C9 16.0511 8.92098 15.8603 8.78033 15.7197C8.63968 15.579 8.44891 15.5 8.25 15.5ZM6 16.25C6 15.9545 6.0582 15.6619 6.17127 15.389C6.28434 15.116 6.45008 14.8679 6.65901 14.659C6.86794 14.4501 7.11598 14.2843 7.38896 14.1713C7.66194 14.0582 7.95453 14 8.25 14C8.54547 14 8.83806 14.0582 9.11104 14.1713C9.38402 14.2843 9.63206 14.4501 9.84099 14.659C10.0499 14.8679 10.2157 15.116 10.3287 15.389C10.4418 15.6619 10.5 15.9545 10.5 16.25C10.5 16.8467 10.2629 17.419 9.84099 17.841C9.41903 18.2629 8.84674 18.5 8.25 18.5C7.65326 18.5 7.08097 18.2629 6.65901 17.841C6.23705 17.419 6 16.8467 6 16.25ZM12.25 10C12.0511 10 11.8603 10.079 11.7197 10.2197C11.579 10.3603 11.5 10.5511 11.5 10.75C11.5 10.9489 11.579 11.1397 11.7197 11.2803C11.8603 11.421 12.0511 11.5 12.25 11.5H17.25C17.4489 11.5 17.6397 11.421 17.7803 11.2803C17.921 11.1397 18 10.9489 18 10.75C18 10.5511 17.921 10.3603 17.7803 10.2197C17.6397 10.079 17.4489 10 17.25 10H12.25ZM11.5 16.25C11.5 16.0511 11.579 15.8603 11.7197 15.7197C11.8603 15.579 12.0511 15.5 12.25 15.5H17.25C17.4489 15.5 17.6397 15.579 17.7803 15.7197C17.921 15.8603 18 16.0511 18 16.25C18 16.4489 17.921 16.6397 17.7803 16.7803C17.6397 16.921 17.4489 17 17.25 17H12.25C12.0511 17 11.8603 16.921 11.7197 16.7803C11.579 16.6397 11.5 16.4489 11.5 16.25ZM6.75 6C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5H17.25C17.4489 7.5 17.6397 7.42098 17.7803 7.28033C17.921 7.13968 18 6.94891 18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H6.75Z"
                        fill="white" />
                    </svg> -->
                    <!-- <i class="fa fa-times"></i>&nbsp; -->
  
                    Cancel POC
                  </button></li>
  
  
                <!-- <li class="list-inline-item"  *ngIf="!isOffLinePOC()">
        <span >
          <label for="switch" class="font-weight-bold">Show Video</label>
          <div class="switchToggle">
            <input type="checkbox" checked id="switch" (click)="showHideVideo()">
            <label for="switch"></label>
          </div>
        </span>
     
      
   
    </li> -->
  
  
              </ul>
            </ng-container>
            <!-- SELF END -->
            <div class="drag" id="drogVideo">
              <div class="card videobg shadow videoalign" id='videoFrame'>
                <div class="card-header pb-1 pt-1 text-white mx-auto">Video Consultation</div>
                <div class="card-body pt-1">
                  <div id="conference_div">
                    <div id="container">
                      <!-- <video id="localStream" autoplay controls
          class='localStream doc_video test'></video>
      <video muted autoplay controls class='remoteStream pat_video'></video> -->
      <openvidu-webcomponent style="display: none; min-height:300px" ></openvidu-webcomponent>
                    </div>
                    <div>
                      <input id="convId" type="hidden" />
                    </div>
                    <div>
                      <ul id="log" style="display: none;"></ul>
                      <!-- <button onclick="window.app.leaveConversation()"
                        class="btn btn-sm btn-danger">Hang Up</button>&nbsp;
                    <button class="btn btn-sm btn-success">Confirm</button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
          </aside>
  
        </div>
      </div>

      <!---Section Two-->
      
      <!---Section Two End-->

    </div>

    <hr class="mt-0 mb-0" style="border-top: 1px solid #17c5bb;">

    <div class="row">
      <div class="col-xl-12">
      <div class="stc">


        <!-- <div class="tbs-menu" *ngIf="!pocForm.get('is_epaper')?.value">
          <div class="patient" id="patient-tbs">
            <ul class="nav nav-pills nav-pills1 " id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="nav-link active " id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab"
                  aria-controls="pills-home" aria-selected="true">Plan Of Care</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab"
                  aria-controls="pills-profile" aria-selected="false">Vitals & History</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab"
                  aria-controls="pills-contact" aria-selected="false">Investigations</a>
              </li>
              <li class="nav-item" role="presentation" *ngIf="isQA">
                <a class="nav-link" id="pills-voice-tab" data-toggle="pill" href="#pills-voice" role="tab"
                  aria-controls="pills-voice" aria-selected="false">Voice Recognition</a>
              </li>
            </ul>
            <hr class="mb-2 mt-0 mb-3">
          </div>
        </div> -->
        <form [formGroup]="pocForm"  *ngIf="!pocForm.get('is_epaper')?.value">
        
        <!-- <form [formGroup]="pocForm" (keydown.enter)="$event.preventDefault()" (ngSubmit)="onSubmit($event)" *ngIf="!pocForm.get('is_epaper')?.value"> -->
       
          <!-- new mom world banck changes statrt 15-02-2023 -->
          <div class="scrollable-menu">
            <h4 class="text-center mb-1 mt-1" style="font-weight: 700; color: darkblue;">Plan of Care</h4>

            <hr class="mt-0 mb-0">

             <!-- VITAL start-->
           

        
            <!-- VITAL END-->

         
            <!-- CHIEF COMPLAINTS END-->

           
            <!-- History of Present Illness end -->

             

            


            <!-- DRUGS END -->


             

          
          </div>


          
<div class=""  >
            <div class="row">
              <div class="col-xl-6">
                <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
                  <h5 class="card-header">Vitals</h5>
                  <div class="card-body" formGroupName="vital_history">
                    <div class="row">
                    <div class="col-xl-4" *ngIf="vtlDt!=''">
                      <div class="form-group">
                        <label for="inputEmail4"><b>Date:&nbsp; </b></label>{{vtlDt}}
                      </div>
                    </div>
                    <div class="col-xl-4" *ngIf="vtlTm!=''">
                      <div class="form-group">
                        <label for="inputEmail4"><b>Time:&nbsp; </b></label>{{vtlTm}}
                      </div>
                    </div>
                    </div>
                    <div class="row">
                      <!-- Temperature -->
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="inputEmail4">Temperature</label>
                          <div class="input_wrapper">
                            <input type="text" formControlName="temperature" id="temperature"
                              (change)="onTempChng($event.target.value)" maxlength="5"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46'
                              [ngClass]="{ 'is-invalid': (pocForm.get('vital_history.temperature').errors || tempErrMsg) }"
                              class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase" (keyup)="onTempChng($event.target.value)" />
                            <div class="unit">&deg; F</div>
                            <div *ngIf="pocForm.get('vital_history.temperature').errors" class="invalid-feedback">
                              <div>Accept value from 85 to 110</div>
                            </div>
                            <div *ngIf="tempErrMsg" class="invalid-feedback">
                              <!-- pocForm.get('vital_history.temperature').errors.pattern -->
                              <div> Enter Valid Decimal format. Eg.: 98.7 or 100.2 </div>
                            </div>
                          </div>
                        </div>
  
                      </div>
                      <!-- Temerature END -->
  
                      <!-- SUGAR -->
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="inputEmail4">Sugar(mg/dl)</label>
                          <div class="input_wrapper">
                            <input type="text" autocomplete="off" formControlName="diabetic_value"
                              id="diabetic_value"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                              class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase"
                              [ngClass]="{ 'is-invalid': pocForm.get('vital_history.diabetic_value').errors }">
                            <div *ngIf="pocForm.get('vital_history.diabetic_value').errors"
                              class="invalid-feedback">
                              <div *ngIf="pocForm.get('vital_history.diabetic_value').errors.min">Accept value from
                                50
                                to 800
                              </div>
                              <div *ngIf="pocForm.get('vital_history.diabetic_value').errors.max">Accept value from
                                50
                                to 800
                              </div>
                              <div *ngIf="pocForm.get('vital_history.diabetic_value').errors.required">Sugar is
                                required</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- SUGAR END -->
  
                      <!-- Systolic -->
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="inputEmail4">Systolic</label>
                          <div class="input_wrapper">
                            <input type="text" autocomplete="off" formControlName="systolic" id="systolic"
                              (keyup)="keyUp('systolic')" (change)="onSysDia()"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57)' maxlength="3"
                              [ngClass]="{ 'is-invalid': pocForm.get('vital_history.systolic').errors }"
                              class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase">
                            <div class="unit">mm Hg</div>
                            <div *ngIf=" pocForm.get('vital_history.systolic').errors" class="invalid-feedback">
                              <div *ngIf="pocForm.get('vital_history.systolic').errors.min">Accept value from 50 to
                                250</div>
                              <div *ngIf="pocForm.get('vital_history.systolic').errors.max">Accept value from 50 to
                                250</div>
                              <div *ngIf="pocForm.get('vital_history.systolic').errors.sys">Enter Valid Value</div>
                              <div *ngIf="pocForm.get('vital_history.systolic').errors.required">Systolic is
                                required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <!-- Systolic END -->
  
                      <!-- Diastolic -->
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="inputEmail4">Diastolic</label>
                          <div class="input_wrapper">
                            <input type="text" autocomplete="off" formControlName="diastolic" id="diastolic"
                              (keyup)="keyUp('diastolic')" (change)="onSysDia()"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                              [ngClass]="{ 'is-invalid': pocForm.get('vital_history.diastolic').errors }"
                              class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase">
                            <div class="unit">mm Hg</div>
                            <div *ngIf=" pocForm.get('vital_history.diastolic').errors" class="invalid-feedback">
                              <div *ngIf="pocForm.get('vital_history.diastolic').errors.min"> Accept value from 40
                                to
                                160
                              </div>
                              <div *ngIf="pocForm.get('vital_history.diastolic').errors.max"> Accept value from 40
                                to
                                160
                              </div>
                              <div *ngIf="pocForm.get('vital_history.diastolic').errors.dia">Diastolic should be
                                less
                                than
                                Systolic</div>
                              <div *ngIf="pocForm.get('vital_history.diastolic').errors.required">Diastolic is
                                required</div>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <!-- Diastolic END -->
  
                      <!-- Hemoglobin -->
                      <div class="col-xl-6" *ngIf="!hidehmrbs">
                        <div class="form-group">
                          <label for="inputEmail4">Hemoglobin</label>
                          <div class="input_wrapper">
                            <input type="text" autocomplete="off" formControlName="hemoglobin" id="hemoglobin"
                              maxlength="4"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46'
                              class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase" (change)="onHmglbnChng($event.target.value)">
                            <!-- (keyup)="onHmglbnChng($event.target.value)" [ngClass]="{ 'is-invalid': pocForm.get('vital_history.hemoglobin').errors }" -->
                          </div>
                        </div>
  
                      </div>
  
                      <!-- Hemoglobin END-->
  
                      <!-- RBS -->
                      <div class="col-xl-6" *ngIf="!hidehmrbs">
                        <div class="form-group">
                          <label for="inputEmail4">RBS</label>
                          <div class="input_wrapper">
                            <input type="text" autocomplete="off" formControlName="rbsk" id="rbsk"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="30"
                              [ngClass]="{ 'is-invalid': pocForm.get('vital_history.rbsk').errors }"
                              class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase">
                          </div>
                        </div>
                      </div>
                      <!-- RBS END-->
  
                      <!-- Pulse -->
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="inputEmail4">Pulse</label>
                          <div class="input_wrapper">
                            <input type="text" autocomplete="off" formControlName="pulse" id="pulse"
                              (keyup)="keyUp('pulse')"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57)' maxlength="3"
                              max="200" [ngClass]="{ 'is-invalid': pocForm.get('vital_history.pulse').errors }"
                              class="form-control form-control-sm form-control form-control-sm-sm  text-uppercase">
                            <div class="unit">bpm</div>
                            <div *ngIf=" pocForm.get('vital_history.pulse').errors" class="invalid-feedback">
                              <div *ngIf="pocForm.get('vital_history.pulse').errors.min">Accept value from is 40 to
                                200</div>
                              <div *ngIf="pocForm.get('vital_history.pulse').errors.max">Accept value from is 40 to
                                200</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Pulse END-->
  
                      <!-- SPO2 -->
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="inputEmail4">SpO<sub>2</sub></label>
                          <div class="input_wrapper">
                            <input type="text" autocomplete="off" formControlName="oxigen_count" id="oxigen_count"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                              class="form-control form-control-sm  text-uppercase"
                              [ngClass]="{ 'is-invalid': pocForm.get('vital_history.oxigen_count').errors }">
                            <div *ngIf="pocForm.get('vital_history.oxigen_count').errors" class="invalid-feedback">
                              <div *ngIf="pocForm.get('vital_history.oxigen_count').errors.min">Accept value from 0
                                to
                                100
                              </div>
                              <div *ngIf="pocForm.get('vital_history.oxigen_count').errors.max">Accept value from 0
                                to
                                100
                              </div>
                              <div *ngIf="pocForm.get('vital_history.oxigen_count').errors.required">SpO2 is
                                required
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- SPO2 END-->
  
                      <!-- Height -->
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="inputEmail4">Height(cm)</label>
                          <div class="input_wrapper">
                            <input type="text" autocomplete="off" formControlName="height" id="height"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="6"
                              (keyup)="onTempChng($event.target.value)" class="form-control form-control-sm  text-uppercase"
                              [ngClass]="{ 'is-invalid': pocForm.get('vital_history.height').errors}" (change)="bmiCheck()">
                            <div class="unit">cm</div>
                            <div *ngIf="pocForm.get('vital_history.height').errors" class="invalid-feedback">
                              <div *ngIf="pocForm.get('vital_history.height').errors.min">Accept value from 30 to
                                240
                              </div>
                              <div *ngIf="pocForm.get('vital_history.height').errors.max">Accept value from 30 to
                                240
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <!-- Height END -->
  
                      <!-- Weight  -->
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label for="inputEmail4">Weight</label>
                          <div class="input_wrapper">
                            <input type="text" autocomplete="off" formControlName="weight" id="weight"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="6"
                              class="form-control form-control-sm  text-uppercase"
                              [ngClass]="{ 'is-invalid': pocForm.get('vital_history.weight').errors }" (change)="bmiCheck()">
                            <div class="unit">kg</div>
                            <div *ngIf="pocForm.get('vital_history.weight').errors" class="invalid-feedback">
                              <div *ngIf="pocForm.get('vital_history.weight').errors.min">Accept value from 1 to 250
                              </div>
                              <div *ngIf="pocForm.get('vital_history.weight').errors.max">Accept value from 1 to 250
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Weight END -->

                      <div class="col-xl-3">
                          <label>BMI</label>
                            <input type="text" autocomplete="off" formControlName="bmi" [(ngModel)]="bmi" id="bmi"
                              class="form-control form-control-sm" disabled> 
                              <label class="form-label" [style.color]="bmiTxtClr(bmi, 'c')">
                                <strong>{{bmiTxtClr(bmi, 't')}}</strong>
                            </label>
                      </div>
  
                      <!-- Vital Button -->
                      <!-- <div class="col-xl-12 text-right">
                        <div class="form-group mb-0">
                        
                        </div>
                      </div> -->
                      <!-- Vital Button END -->
                    </div>
  
  
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                   <!-- CHIEF COMPLAINTS start-->
            <div class="cards h-100  mr-3 shadow-sm" style="border-radius: 1rem;">
            
              <h5 class="card-header">Chief Complaints
                <span class="text-danger">*</span>
              <a role="button" style="cursor: pointer; color: #8C8C8C !important; font-size: 16px !important;" (click)="LoadMO('CC')" *ngIf="moreCC"
                class="ml-5"><b>{{txtMoreCC}}</b></a>&nbsp;&nbsp;
              </h5> 
              <div class="card-body pb-0">
                <div class="badge1">
                  <!-- <span><a  class="badge badge-primary pt-2  pb-2 mr-2 ">Cough</a></span> -->

                  <span *ngIf="ccCgh">
                    <a (click)="onCCButtonSelect('Cough')"
                      class="badge badge-primary pt-2  pb-2 mr-2 ">Cough</a>
                    <input type="checkbox" style="display: none;" />
                  </span>

                  <span *ngIf="ccPrd">
                    <a (click)="onCCButtonSelect('Pain or Discomfort')"
                      class="badge badge-primary pt-2  pb-2 mr-2 ">Pain or Discomfort</a>
                    <input type="checkbox" style="display: none;" checked />
                  </span>

                  <span *ngIf="ccRef">
                    <a (click)="onCCButtonSelect('Recurrent fever')"
                      class="badge badge-primary pt-2  pb-2 mr-2 ">Recurrent Fever</a>
                    <input type="checkbox" style="display: none;" checked />
                  </span>

                  <span *ngIf="ccSwl">
                    <a (click)="onCCButtonSelect('Swelling')"
                      class="badge badge-primary pt-2  pb-2 mr-2 ">Swelling</a>
                    <input type="checkbox" style="display: none;" checked />
                  </span>

                  <span *ngIf="ccOther">
                    <a (click)="onCCButtonSelect('Other')"
                      class="badge badge-primary pt-2  pb-2 mr-2 ">Other</a>
                    <input type="checkbox" style="display: none;" checked />
                  </span>

                </div>
                <div formGroupName="cc_brief_history">
                  <div class="form-group mb-0">
                    <!-- <label for="inputEmail4">Chief Complaints <span class="text-danger">*</span>
                      <a role="button" style="cursor: pointer;" (click)="LoadMO('CC')" *ngIf="moreCC"
                        class="ml-5"><b>{{txtMoreCC}}</b></a>&nbsp;&nbsp;

                    </label> -->
                    <div tabindex="0" class="">

                      <ng-multiselect-dropdown [settings]="ccdropdownSettings" [placeholder]="'Select'"
                        (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)"
                        [(ngModel)]="selectedItemscc" [ngModelOptions]="{standalone: true}"
                        [data]="chiefComplaintList" 
                        [formControl]="pocForm.get('cc_brief_history.chiefComplaints')"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.chiefComplaints').errors }">
                      </ng-multiselect-dropdown>
                      <div *ngIf="submitted && pocForm.get('cc_brief_history.chiefComplaints').errors"
                        class="invalid-feedback">
                        <div *ngIf="pocForm.get('cc_brief_history.chiefComplaints').errors.required">
                          Chief Complaints is required
                        </div>
                      </div>
                    </div>
                  </div>



                  <div class="form-group" *ngIf="showTestField==1">
                    <label for="inputEmail4">Other (if any) </label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="othersifany" id="othersifany"
                        (keyup)="keyUp('othersifany')" maxlength="500" class="form-control form-control-sm  text-uppercase"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                      (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)'
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.othersifany').errors }">
                      <div *ngIf="submitted && pocForm.get('cc_brief_history.othersifany').errors"
                        class="invalid-feedback">
                        <div *ngIf="pocForm.get('cc_brief_history.othersifany').errors.required">
                          Other (if any) is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="form-group">
                  <label for="inputEmail4">History of Present Illness</label>
                  <div>
                    <input type="text" autocomplete="off" formControlName="presentIllness" id="presentIllness"
                      (keyup)="keyUp('presentIllness')" maxlength="3500"
                      class="form-control form-control-sm  text-uppercase"
                      onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                    (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)'
                      [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.presentIllness').errors }">
                  </div>
                </div>
                <div class="form-group">
                  <label for="inputEmail4">Family History</label>
                  <div>
                    <input type="text" autocomplete="off" formControlName="familyhistory" id="familyhistory"
                      (keyup)="keyUp('familyhistory')" maxlength="500"
                      class="form-control form-control-sm  text-uppercase"
                      onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                    (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)'
                      [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.familyhistory').errors }">
                  </div>
                </div> -->

                </div>
              </div>
            </div>
              </div>

              <div class="col-xl-6 mb-3"> <!-- History of Present Illness start  -->
                <div class="cards h-100 h-100 mt-4 mr-3 shadow-sm" style="border-radius: 1rem;">
                  <h5 class="card-header"> History of Present Illness</h5>
                  <div class="card-body">
  
                    <div formGroupName="cc_brief_history">
  
                      <div class="form-group">
                        <!-- <label for="inputEmail4">History of Present Illness</label> -->
                        <div>
                          <!-- below line commented 14-12-2022 -->
                          <!-- <textarea rows="3"  class="form-control form-control-sm  text-uppercase" (keyup)="keyUp('presentIllness')"  -->
                            <textarea rows="3"  class="form-control form-control-sm  text-uppercase"                              
                            formControlName="presentIllness" maxlength="300"  [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.presentIllness').errors }">
                      </textarea>
                          <!-- <input type="text" autocomplete="off" formControlName="presentIllness" id="presentIllness"
                            (keyup)="keyUp('presentIllness')" maxlength="300" class="form-control form-control-sm  text-uppercase"
                            onkeypress='return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || (event.charCode == 44) ||(event.charCode == 46) ||
                           (event.charCode == 40) ||(event.charCode == 41)|| (event.charCode == 58) ||(event.charCode == 63)|| (event.charCode == 64) ||
                           (event.charCode == 45) ||(event.charCode == 95)|| (event.charCode == 37) ||(event.charCode == 38)||(event.charCode == 42) ||
                           (event.charCode == 32) || ((event.charCode >= 48 && event.charCode <= 57))'
                            [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.presentIllness').errors }"> -->
                            <!-- <textarea formControlName="presentIllness" id="presentIllness" rows="5" class="form-control form-control-sm"> </textarea> -->
     
                          </div>
                      </div>  
                    </div>  
                  </div>
                </div></div>
              <div class="col-xl-6 mb-3">
                <!-- Provisional Diagnosis start -->
             <div class="cards h-100 mt-4 mr-3 shadow-sm" style="border-radius: 1rem;">
              <h5 class="card-header">Provisional Diagnosis  <span class="text-danger" *ngIf="enableProvisionalDiagnosis">*</span></h5>
              <div class="card-body">
                <div class="badge1 mb-0">
                  <!-- <span><a  class="badge badge-primary pt-2  pb-2 mr-2 ">Cough</a></span> -->
                  <span *ngIf="pdOther">
                    <a (click)="onPdButtonSelect('Other')"
                      class="badge badge-primary pt-2  pb-2 mr-2 ">Other</a>
                    <input type="checkbox" style="display: none;" />
                  </span>


                </div>
                <div formGroupName="diagnosis">
                  <div class="form-group">
                    <label for="inputEmail4">Type Of Diagnosis
                      <span class="text-danger" *ngIf="enableProvisionalDiagnosis"></span>
                      <a role="button" style="cursor: pointer;" (click)="LoadMO('PD')" *ngIf="morePD"
                        class="ml-5"><b>{{txtMorePD}}</b></a>&nbsp;&nbsp;

                    </label>
                    <div>
                      <!--sushma 22-07-2022 type of diagnosis values based on search  -->
                      <input type="text" class="form-control form-control-sm form-control form-control-sm-sm mb-1" [(ngModel)]="typeOfdiagnosis"
                        [ngModelOptions]="{standalone: true}" (keyup)="typeDiagnosis()" id="txtdiagno"
                        Placeholder="Please Enter Minimum 3 Characters">
                        <div *ngIf="submitted && pocForm.get('diagnosis.provisionalDiagnosis').errors"
                        class="invalid-feedback">
                        <div *ngIf="pocForm.get('diagnosis.provisionalDiagnosis').errors.required">
                          Provisional Diagnosis is required
                        </div>
                      </div>
                      <!-- <ng-multiselect-dropdown [settings]="diagnosysdropdownSettings" [placeholder]="'Select'"
                  (onSelect)="onSelectPD($event, 's')" (onDeSelect)="onSelectPD($event, 'd')"  [(ngModel)]="selectedItemstd"
                  [ngModelOptions]="{standalone: true}"
                  [data]="diagnosysgroupList" [formControl]="pocForm.get('diagnosis.provisionalDiagnosis')">
                </ng-multiselect-dropdown> -->
                      <!--  -->
                      <div *ngIf="(typeOfdiagnosis?.length > 2) || checkedLst.length > 0">
                        <ng-multiselect-dropdown [settings]="diagnosysdropdownSettings" [placeholder]="'Select'"
                          (onSelect)="onSelectPD($event, 's')" (onDeSelect)="onSelectPD($event, 'd')"
                          [(ngModel)]="selectedItemstd" [ngModelOptions]="{standalone: true}"
                          [data]="typeofDiagnosisLst"
                          [formControl]="pocForm.get('diagnosis.provisionalDiagnosis')">
                        </ng-multiselect-dropdown>
                        
                      </div>
                      
                    </div>
                  </div>

                  <div class="form-group" *ngIf="isShowPDOthr">
                    <label for="inputEmail4">Other (if any) </label>
                    <div>
                      <textarea style="resize: none; height: 100px;" autocomplete="off"
                        formControlName="othersifany" maxlength="500" class="form-control form-control-sm "
                        id="pdOthers"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Provisional Diagnosis END-->
              </div>

              
              <div class="col-xl-12 mb-2" *ngIf="EnableOptimetryDetailsInPOC" formGroupName="eye_prescription">
                <div class="cards h-100 mt-4 mr-3 shadow-sm" style="border-radius: 1rem;">
                  <h6 class="card-header">Optimetry Details <span class="text-danger" *ngIf="enableProvisionalDiagnosis">*</span></h6>
                  <div class="card-body">
              
                    <!-- Date Input -->
                    <div class="d-flex justify-content-end mb-2">
                      <!-- <div class="float-right">
                        <div class="input-group">
                          <label for="date" class="me-2" style="font-size: 0.85rem;">Date:</label>&nbsp;&nbsp;
                          <input id="from_date" name="from_date" type="text" autocomplete="off" onpaste="return false" placeholder="DD-MM-YYYY"
                            bsDatepicker #dp="bsDatepicker" (focus)="dp.show()"
                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false, adaptivePosition: true, isAnimated: true }"
                            class="form-control form-control-sm">
                        </div>
                      </div> -->
                    </div>
              
                    <!-- Prescription Table -->
                    <table class="table table-bordered text-center">
                      <thead class="p-1">
                        <tr>
                          <th class="p-1"></th>
                          <th colspan="3" class="p-1">RIGHT EYE</th>
                          <th colspan="3" class="p-1">LEFT EYE</th>
                        </tr>
                        <tr>
                          <th class="p-1"></th>
                          <th class="p-1">SPH</th>
                          <th class="p-1">CYL</th>
                          <th class="p-1">AXIS</th>
                          <th class="p-1">SPH</th>
                          <th class="p-1">CYL</th>
                          <th class="p-1">AXIS</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="p-1">Distance Constance</td>
                          <!-- RIGHT SPH -->
                          <td>
                            <input type="text" class="form-control form-control-sm" formControlName="righteye_sph" (keypress)="keyPressNumbers($event)">
                            <div *ngIf="pocForm.get('eye_prescription.righteye_sph')?.touched && pocForm.get('eye_prescription.righteye_sph')?.invalid">
                              <small *ngIf="pocForm.get('eye_prescription.righteye_sph')?.errors?.invalidFormat" style="color: red;">Invalid format. Use +/- with 2 decimals.</small>
                              <small *ngIf="pocForm.get('eye_prescription.righteye_sph')?.errors?.outOfRange" style="color: red;">Value must be between -20.00 and +20.00</small>
                            </div>
                          </td>
              
                          <!-- RIGHT CYL -->
                          <td>
                            <input type="text" class="form-control form-control-sm" formControlName="righteye_cyl" (keypress)="keyPressNumbers($event)">
                            <div *ngIf="pocForm.get('eye_prescription.righteye_cyl')?.touched && pocForm.get('eye_prescription.righteye_cyl')?.invalid">
                              <small *ngIf="pocForm.get('eye_prescription.righteye_cyl')?.errors?.invalidFormat" style="color: red;">Invalid format.</small>
                              <small *ngIf="pocForm.get('eye_prescription.righteye_cyl')?.errors?.outOfRange" style="color: red;">Value must be between -6.00 and +6.00</small>
                            </div>
                          </td>
              
                          <!-- RIGHT AXIS -->
                          <td>
                            <input type="text" class="form-control form-control-sm" formControlName="righteye_axis" (keypress)="keyPressNumbers($event)">
                            <div *ngIf="pocForm.get('eye_prescription.righteye_axis')?.touched && pocForm.get('eye_prescription.righteye_axis')?.invalid">
                              <small *ngIf="pocForm.get('eye_prescription.righteye_axis')?.errors?.invalidFormat">Enter integer</small>
                              <small *ngIf="pocForm.get('eye_prescription.righteye_axis')?.errors?.outOfRange" style="color: red;">Value must be between 0 and 180</small>
                            </div>
                          </td>
              
                          <!-- LEFT SPH -->
                          <td>
                            <input type="text" class="form-control form-control-sm" formControlName="lefteye_sph" (keypress)="keyPressNumbers($event)">
                            <div *ngIf="pocForm.get('eye_prescription.lefteye_sph')?.touched && pocForm.get('eye_prescription.lefteye_sph')?.invalid">
                              <small *ngIf="pocForm.get('eye_prescription.lefteye_sph')?.errors?.invalidFormat"style="color: red;">Invalid format.</small>
                              <small *ngIf="pocForm.get('eye_prescription.lefteye_sph')?.errors?.outOfRange" style="color: red;">Value must be between -20.00 and +20.00</small>
                            </div>
                          </td>
              
                          <!-- LEFT CYL -->
                          <td>
                            <input type="text" class="form-control form-control-sm" formControlName="lefteye_cyl" (keypress)="keyPressNumbers($event)">
                            <div *ngIf="pocForm.get('eye_prescription.lefteye_cyl')?.touched && pocForm.get('eye_prescription.lefteye_cyl')?.invalid">
                              <small *ngIf="pocForm.get('eye_prescription.lefteye_cyl')?.errors?.invalidFormat" style="color: red;">Invalid format.</small>
                              <small *ngIf="pocForm.get('eye_prescription.lefteye_cyl')?.errors?.outOfRange" style="color: red;">Value must be between -6.00 and +6.00</small>
                            </div>
                          </td>
              
                          <!-- LEFT AXIS -->
                          <td>
                            <input type="text" class="form-control form-control-sm" formControlName="lefteye_axis" (keypress)="keyPressNumbers($event)">
                            <div *ngIf="pocForm.get('eye_prescription.lefteye_axis')?.touched && pocForm.get('eye_prescription.lefteye_axis')?.invalid">
                              <small *ngIf="pocForm.get('eye_prescription.lefteye_axis')?.errors?.invalidFormat">Enter integer</small>
                              <small *ngIf="pocForm.get('eye_prescription.lefteye_axis')?.errors?.outOfRange" style="color: red;">Value must be between 0 and 180</small>
                            </div>
                          </td>
                        </tr>
              
                        <tr>
                          <td class="p-1">Reading Addition</td>
                          <td>
                            <input type="text" class="form-control form-control-sm" formControlName="righteye_reading_addition" (keypress)="keyPressNumbers($event)">
                            <div *ngIf="pocForm.get('eye_prescription.righteye_reading_addition')?.touched && pocForm.get('eye_prescription.righteye_reading_addition')?.invalid">
                              <small *ngIf="pocForm.get('eye_prescription.righteye_reading_addition')?.errors?.invalidFormat" style="color: red;">Use + format (e.g. +2.25)</small>
                              <small *ngIf="pocForm.get('eye_prescription.righteye_reading_addition')?.errors?.outOfRange" style="color: red;">Between +0.25 and +3.50</small>
                            </div>
                          </td>
                          <td colspan="2"></td>
                          <td>
                            <input type="text" class="form-control form-control-sm" formControlName="lefteye_reading_addition" (keypress)="keyPressNumbers($event)">
                            <div *ngIf="pocForm.get('eye_prescription.lefteye_reading_addition')?.touched && pocForm.get('eye_prescription.lefteye_reading_addition')?.invalid">
                              <small *ngIf="pocForm.get('eye_prescription.lefteye_reading_addition')?.errors?.invalidFormat" style="color: red;">Use + format (e.g. +2.25)</small>
                              <small *ngIf="pocForm.get('eye_prescription.lefteye_reading_addition')?.errors?.outOfRange" style="color: red;">Between +0.25 and +3.50</small>
                            </div>
                          </td>
                          <td colspan="2"></td>
                        </tr>
                      </tbody>
                    </table>
                    <table class="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th style="text-align: center;">Type of Lens</th>
                          <th style="text-align: center;">Colour of Lens</th>
                          <th style="text-align: center;">Segment Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="text-align: center;">
                              <select id="lensType" class="form-control form-control-sm" formControlName="type_of_lens_id">
                                <option value="">Select</option>
                                <option *ngFor="let lens of typeLensList" [value]="lens.id">{{lens.name}}</option>
                              </select>
                              
                          </td>
                          <td style="text-align: center;">
                            <select id="lensColor" class="form-control form-control-sm" formControlName="colour_of_lens_id">
                              <option value="">Select</option>
                              <option *ngFor="let lens of colourLensList" [value]="lens.id">{{lens.name}}</option>
                            </select>
                          </td>
                          <td>
                            <div class="row mb-2">
                              <div class="col-xl-5"></div>
                              <div class="col-xl-1 mb-2"><label for="inputEmail4 mt-1">PD:</label></div>
                              <div class="col-xl-6 mb-2">
                                
                                <input type="text" id="pd" class="form-control form-control-sm" formControlName="pd"  (keypress)="keyPressNumbers($event)">
                                <div *ngIf="pocForm.get('eye_prescription.pd')?.touched && pocForm.get('eye_prescription.pd')?.invalid">
                                  <small *ngIf="pocForm.get('eye_prescription.pd')?.errors?.outOfRange" style="color: red;">Value must be between 20 and 80</small>
                                </div>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-xl-5"></div>
                                <div class="col-xl-1"> <label for="inputEmail4 mt-1">BVD:</label></div>
                              <div class="col-xl-6">
                             
                               
                                <input type="text" id="bvd" class="form-control form-control-sm" formControlName="bvd"  (keypress)="keyPressNumbers($event)">
                                <div *ngIf="pocForm.get('eye_prescription.bvd')?.touched && pocForm.get('eye_prescription.bvd')?.invalid">
                                  <small *ngIf="pocForm.get('eye_prescription.bvd')?.errors?.outOfRange" style="color: red;">Value must be between 0 and 20</small>
                                </div>
                              </div>

                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- Lens & Segment Details -->

              
                    <!-- Doctor -->
                    <!-- <p class="text-end fw-bold" style="font-size: 0.9rem;">Baby Boy AJITH KUMAR RAI</p>
                    <p class="text-end text-muted" style="font-size: 0.8rem;">Ophthalmologist/Optometrist</p> -->
                  </div>
                </div>
              </div>
              



              <div class="col-xl-6 mb-3">
                <!-- ADVICE start -->
            <div class="cards h-100 mt-4 mr-3 shadow-sm" *ngIf="isEnableAdviceAllField" >
              <h5 class="card-header">Advice</h5>
              <div class="card-body " formGroupName="advice">
                <div class="row">
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Rest/Exercise</label>
                    <div>
                      <textarea type="text" autocomplete="off" formControlName="restExercise" id="restExercise"
                        (keyup)="keyUp('restExercise')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
(event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
(event.charCode == 32 || event.charCode == 46))' maxlength="300" style="resize: none;"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.restExercise').errors }"
                        class="form-control form-control-sm  text-uppercase"></textarea>
                    </div>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="inputPassword4">Diet</label>
                    <div>
                      <textarea type="text" autocomplete="off" formControlName="diet" id="diet"
                        (keyup)="keyUp('diet')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
(event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
(event.charCode == 32 || event.charCode == 46))' maxlength="300" style="resize: none;"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.diet').errors }"
                        class="form-control form-control-sm  text-uppercase"></textarea>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Follow Advice</label>
                    <div>
                      <textarea type="text" autocomplete="off" formControlName="followAdvice" id="followAdvice"
                        (keyup)="keyUp('followAdvice')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
(event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
(event.charCode == 32 || event.charCode == 46))' maxlength="300" style="resize: none;"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.followAdvice').errors }"
                        class="form-control form-control-sm  text-uppercase"></textarea>
                    </div>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Doctor Comments</label>
                    <div>
                      <!-- <input type="text" autocomplete="off" formControlName="doctorComment" id="doctorComment"
(keyup)="keyUp('doctorComment')" maxlength="100" (focus)="dp.hide()"
onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
(event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) ||
(event.charCode >= 48 && event.charCode <= 57)'
[ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.doctorComment').errors }"
class="form-control form-control-sm  text-uppercase"> -->
                      <textarea type="text" autocomplete="off" formControlName="doctorComment"
                        id="doctorComment" (keyup)="keyUp('doctorComment')" maxlength="300" (focus)="dp.hide()"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
(event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) ||
(event.charCode >= 48 && event.charCode <= 57)' style="resize: none;"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.doctorComment').errors }"
                        class="form-control form-control-sm  text-uppercase"></textarea>
                    </div>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Follow up Date</label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="followupDate" id="followupDate"
                        placeholder="Follow up Date" bsDatepicker [minDate]="minDate" #dp="bsDatepicker"
                        (focus)="dp.show()"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false,adaptivePosition: true,isAnimated: true }"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.followupDate').errors }"
                        class="form-control form-control-sm ">
                    </div>
                  </div>
                </div>

                <!-- <div class="row" *ngIf="!isEnableAdviceAllField">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <!-- <label for="inputEmail4">Rest/Exercise</label> -->
                      <!-- <div> -->
                        <!-- below line commented 14-12-2022 -->
                        <!-- <textarea rows="3"   (keyup)="keyUp('restExercise')"  -->
                          <!-- <textarea rows="3"  formControlName="restExercise" maxlength="3000"  [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.restExercise').errors }"
                          class="form-control form-control-sm  text-uppercase">
                    </textarea> -->
                        <!-- <textarea type="text" autocomplete="off" formControlName="restExercise" id="restExercise"
                          (keyup)="keyUp('restExercise')" 
                          onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                          (event.charCode == 40) ||(event.charCode == 41)|| (event.charCode == 58) ||(event.charCode == 63)|| (event.charCode == 64)
                          (event.charCode == 45) ||(event.charCode == 95)|| (event.charCode == 37) ||(event.charCode == 38)||(event.charCode == 42) ||
                       (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)'
                          maxlength="300" style="resize: none;"
                          [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.restExercise').errors }"
                          class="form-control form-control-sm  text-uppercase"></textarea> -->
                      <!-- </div>
                    </div>
                  </div> -->

                  <!-- <div class="form-group col-md-6">
                    <label for="inputPassword4">Diet</label>
                    <div>
                        <textarea rows="3" formControlName="diet" maxlength="300" style="resize: none;"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.diet').errors }"
                        class="form-control form-control-sm  text-uppercase">
                  </textarea>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Follow Advice</label>
                    <div>
                        <textarea rows="3" formControlName="followAdvice"  maxlength="300" style="resize: none;"
                     
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.followAdvice').errors }" class="form-control form-control-sm  text-uppercase">
                </textarea>
                      <textarea type="text" autocomplete="off" formControlName="followAdvice" id="followAdvice"
                        (keyup)="keyUp('followAdvice')"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                       (event.charCode == 40) ||(event.charCode == 41)|| (event.charCode == 58) ||(event.charCode == 63)|| (event.charCode == 64)
                       (event.charCode == 45) ||(event.charCode == 95)|| (event.charCode == 37) ||(event.charCode == 38)||(event.charCode == 42) ||
                    (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)'
                        maxlength="300" style="resize: none;"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.followAdvice').errors }"
                        class="form-control form-control-sm  text-uppercase"></textarea>
                    </div>
                  </div>

                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Doctor Comments</label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="doctorComment" id="doctorComment"
(keyup)="keyUp('doctorComment')" maxlength="100" (focus)="dp.hide()"
onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
(event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) ||
(event.charCode >= 48 && event.charCode <= 57)'
[ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.doctorComment').errors }"
class="form-control form-control-sm  text-uppercase">
                       <textarea rows="3"  
                        formControlName="doctorComment" maxlength="300"  [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.doctorComment').errors }"
                       
                        class="form-control form-control-sm  text-uppercase">
                  </textarea>
                    </div>
                  </div> -->

                 
                </div> 
              </div>
            
            <div class="cards h-100 mt-4 mr-3 shadow-sm" *ngIf="!isEnableAdviceAllField" >
              <h5 class="card-header">Advice</h5>
              <div class="card-body " formGroupName="advice">

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <div>
                        <!-- below line commented 14-12-2022 -->
                        <!-- <textarea rows="3"   (keyup)="keyUp('restExercise')"  -->
                          <textarea rows="3"  formControlName="restExercise" maxlength="3000"  [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.restExercise').errors }"
                          class="form-control form-control-sm  text-uppercase">
                    </textarea>
                      
                      </div>
                    </div>
                  </div>


                 
                </div>
              </div>
            </div>
            <!-- ADVICE END -->
              </div>
              <div class="col-xl-6 mb-4">
                
            <!-- Allergies start  -->
            <div class="cards h-100 mt-4 mr-3 shadow-sm" style="border-radius: 1rem;">
              <h5 class="card-header">Allergies <span class="text-danger">*</span></h5>
            <div class="card-body" formGroupName="allergy">
              <!-- <label for="present_illness">Allergies<span class="text-danger">*</span></label> -->
              <div class="form-group mb-0">
                <!-- <label for="inputEmail4">Allergies: </label>
                &nbsp;&nbsp;&nbsp; -->
                
                  <!-- <button type="button" class="btn btn-sm btn-teal"
                    (click)="onAllergyButtonSelect('None')">None</button> -->
                    <span *ngIf="ccCgh">
                      <a (click)="onAllergyButtonSelect('None')"
                        class="badge badge-primary pt-2  pb-2 mr-2 ">None</a>
                      <input type="checkbox" style="display: none;" />
                    </span>
                  
                
                <div>
                  <!-- <input type="text" autocomplete="off" formControlName="allergies" id="allergies"
                    (keyup)="keyUp('allergies')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                    (event.charCode == 40) ||(event.charCode == 41)|| (event.charCode == 58) ||(event.charCode == 63)|| (event.charCode == 64)
                    (event.charCode == 45) ||(event.charCode == 95)|| (event.charCode == 37) ||(event.charCode == 38)||(event.charCode == 42) ||
                    (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)' maxlength="50"
                    [ngClass]="{ 'is-invalid': submitted && pocForm.get('allergy.allergies').errors }"
                    class="form-control form-control-sm  text-uppercase"> -->
                    <!-- <textarea rows="3" class="form-control form-control-sm  text-uppercase"  (keyup)="keyUp('allergies')" -->
                      <textarea rows="3" class="form-control form-control-sm  text-uppercase"  formControlName="allergies"  [ngClass]="{ 'is-invalid': submitted && pocForm.get('allergy.allergies').errors }"
                    >
              </textarea>
                  <div *ngIf="submitted && pocForm.get('allergy.allergies').errors"
                    class="invalid-feedback">
                    <div *ngIf="pocForm.get('allergy.allergies').errors.required">
                      Allergies is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <!-- Allergies end  -->
              </div>
              <!-- AI Development Start -->
             <div class="col-xl-12">
              <div class="text-right mt-4 mb-4">
                <input type="button" class="btn btn-sm btn-primary" value="CDSS" (click)="addPrediction()">
               </div>
              <div class="container-fluid mainrow mt-4">
                <div class="row  row1 flex-nowrap overflow-auto">
           

                    <div class="col-3 flex-grow-0 " *ngFor="let card of cardData">
                        <div class="card h-100 card1">
                            <div class="card-body scroll" >
                                <p class="card-text">
                                  <label> Drug Type</label> : {{card.type}}<br>
                                  <label> Drug Name</label> : {{card.name}}

                            </div>
                            
                        </div>
                    </div>           
                </div>
            </div>
             </div>

              <!-- AI Development End --> 

              <div class="col-xl-6 mb-3" *ngIf="!enableHumanMMU">
                
            <!-- DRUGS start -->
              <!-- DRUGS -->
              <div class="cards h-100 mt-4 mr-3 shadow-sm">
                <h5 class="card-header" *ngIf="!isFeature">Drugs</h5>
                <div class="card-body pb-0" formGroupName="drugs">

                  <!-- <div class="form-group mb-0">
                    <div class="text-right">
                     
                    </div>
                  </div> -->

                  <div class="form-group" *ngIf="!isFeature">
                    <label class="text-left" for="inputEmail4">Drug Type
                      <a role="button" style="cursor: pointer;" (click)="LoadMO('DN')" *ngIf="moreDN"
                        class="ml-5"><b>{{txtMoreDN}}</b></a>
                    </label>

                    <button type="button" class="btn btn-primary btn-sm float-right mb-1" (click)="addRow()">Add Direction</button>

                    <div>
                      <ng-multiselect-dropdown [settings]="drugSettings" id="" [placeholder]="'Select'"
                        [formControl]="pocForm.get('drugs.dT')" (onSelect)="onDrgSlct($event, 'dt')"
                        (onDeSelect)="onDrgDeSlct('dt')" [data]="drugtypesList" [(ngModel)]="dT"
                        [ngModelOptions]="{standalone: true}">
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                  <div *ngIf="disableSearchByDrugName">
                    <div class="form-group"*ngIf="!isFeature">
                      <label for="inputPassword4">Drug Name</label>
                      <!-- <span class="text-danger">*</span> -->
                      <div>
                        <!-- <select formControlName="drugName" id="drugName"
                          [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.drugName').errors }"
                          class="form-control form-control-sm ">
                          <option value="">Select</option>
                          <option *ngFor="let item of drugnamesList" [value]="item.drug_id.id">
                            {{item.drug_id.drug_name}}</option>
                        </select> -->
                        <ng-multiselect-dropdown [settings]="drugNameSettings" [placeholder]="'Select'"
                          [formControl]="pocForm.get('drugs.dN')" (onSelect)="onDrgSlct($event, 'dn')"
                          [data]="drug_list" (onDeSelect)="onDrgDeSlct('dn')" [(ngModel)]="dN"
                          [ngModelOptions]="{standalone: true}"
                          [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.drugName').errors }">
                        </ng-multiselect-dropdown>
                        <div *ngIf="submitted && pocForm.get('drugs.drugName').errors" class="invalid-feedback">
                          <div *ngIf="pocForm.get('drugs.drugName').errors.required">Drug Name is required</div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group" *ngIf="isFeature">
                      <label for="inputEmail4">Search Drug
                        <a role="button" style="cursor: pointer;" 
                          class="ml-5"><b></b></a>&nbsp;&nbsp;

                      </label>
                      <div>
                        <!--sushma 22-07-2022 type of diagnosis values based on search  -->
                        <input type="text" class="form-control form-control-sm form-control form-control-sm-sm mb-1" [(ngModel)]="searchDrug"
                          [ngModelOptions]="{standalone: true}" (keyup)="onDrugSelect()" id="txtdiagno"
                          Placeholder="Please Enter Minimum 3 Characters">
                        <div *ngIf="isFeature && searchDrug?.length>2">
                          <ng-multiselect-dropdown [settings]="searchdrugdropdownSettings" [placeholder]="'Select'"
                            (onSelect)="onSelectdrug($event, 's')" (onDeSelect)="onSelectdrug($event, 'd')"
                            [(ngModel)]="selectedsearchItems" [ngModelOptions]="{standalone: true}"
                            [data]="srhLst"
                            >
                          </ng-multiselect-dropdown>
                        </div>
                      </div>
                    </div>

                    
                  </div>
                  <!-- new lines added for search drug name 07-07-2023 #chandu-->
                  <div *ngIf="!disableSearchByDrugName">
                    <div class="form-group"*ngIf="!isFeature">
                      <label for="inputPassword4">Drug Name</label>
                      <div>
                        <!-- <ng-multiselect-dropdown [settings]="drugNameSettings" [placeholder]="'Select'"
                          [formControl]="pocForm.get('drugs.dN')" (onSelect)="onDrgSlct($event, 'dn')"
                          [data]="drug_list" (onDeSelect)="onDrgDeSlct('dn')" [(ngModel)]="dN"
                          [ngModelOptions]="{standalone: true}"
                          [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.drugName').errors }">
                        </ng-multiselect-dropdown> -->
                        <input type="text" class="form-control form-control-sm form-control form-control-sm-sm mb-1" [(ngModel)]="searchByDrugName"
                        [ngModelOptions]="{standalone: true}" (keyup)="searchDrugName()" id="txtDrugName"
                        Placeholder="Please Enter Minimum 3 Characters">
                        <div *ngIf="submitted && pocForm.get('drugs.drugName').errors" class="invalid-feedback">
                          <div *ngIf="pocForm.get('drugs.drugName').errors.required">Drug Name is required</div>
                        </div>
                        <div *ngIf="(searchByDrugName?.length > 2) || drug_list.length > 0">
                          <ng-multiselect-dropdown [settings]="drugNameSettings" [placeholder]="'Select'"
                          [formControl]="pocForm.get('drugs.dN')" (onSelect)="onDrgSlct($event, 'dn')"
                          [data]="drug_list" (onDeSelect)="onDrgDeSlct('dn')" [(ngModel)]="dN"
                          [ngModelOptions]="{standalone: true}"
                          [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.drugName').errors }">
                        </ng-multiselect-dropdown>
                          </div>
                     
                      </div>
                    </div>

                    <div class="form-group" *ngIf="isFeature">
                      <label for="inputEmail4">Search Drug
                        <a role="button" style="cursor: pointer;" 
                          class="ml-5"><b></b></a>&nbsp;&nbsp;

                      </label>
                      <div>
                        <!--sushma 22-07-2022 type of diagnosis values based on search  -->
                        <input type="text" class="form-control form-control-sm form-control form-control-sm-sm mb-1" [(ngModel)]="searchDrug"
                          [ngModelOptions]="{standalone: true}" (keyup)="onDrugSelect()" id="txtdiagno"
                          Placeholder="Please Enter Minimum 3 Characters">
                        <div *ngIf="isFeature && searchDrug?.length>2">
                          <ng-multiselect-dropdown [settings]="searchdrugdropdownSettings" [placeholder]="'Select'"
                            (onSelect)="onSelectdrug($event, 's')" (onDeSelect)="onSelectdrug($event, 'd')"
                            [(ngModel)]="selectedsearchItems" [ngModelOptions]="{standalone: true}"
                            [data]="srhLst"
                            >
                          </ng-multiselect-dropdown>
                        </div>
                      </div>
                    </div>

                    
                  </div>
                  <!-- end of lines search drug name  -->
                  <div class="form-group" *ngIf="!hideOtherDrugLabel">
                    <label for="inputPassword4">Other Drug Name</label>
                    <div>
                      <input type="text" autocomplete="off" [formControl]="pocForm.get('drugs.otherDrug')"
                        id="otherDrug" (keyup)="keyUp('otherDrug')" maxlength="100"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.otherDrug').errors }"
                        class="form-control form-control-sm  text-uppercase">
                    </div>

                  </div>
                 

                </div>
               


                <!-- <div *ngIf="isukt" class="p-2">
                  <div class="form-group ">
                    <label for="">Type Of Consultation</label>
                    <select [formControl]="pocForm.get('type_of_consultation')" class="form-control form-control-sm ">
                      <option *ngFor="let item of ConsultationList" [value]="item.consultationType">
                        {{item.consultationType}}</option>

                    </select>
                  </div>
                </div>
                <div class="form-group form-check p-2" #myDiv>
                  <input type="checkbox" name="checkbox" [(ngModel)]="isPcChecked"
                    [ngModelOptions]="{standalone: true}" (click)="onPhysicalConsultation($event)">
                  <label  class="form-check-label ml-2" for="exampleCheck1" >Require Physical consultation
                  </label>
                </div> -->

              


                <!-- <div *ngIf="isukt" class="p-2">

                  <div class="form-group" *ngIf="!refdivshow">
                    <label for="">Type Of Referral Hospital</label>
                    <select class="form-control form-control-sm" (change)="onHospTypeChange($event.target.value)"
                      class="form-control form-control-sm ">
                      <option value="">Select</option>
                      <option *ngFor="let item of HospTypeList" [value]="item.id">{{item.hospital_type}}
                      </option>

                    </select>
                  </div>
                  <div class="form-group" *ngIf="!refdivshow && refHospListNew">
                    <label for="">Referral Hospital</label>
                    <ng-multiselect-dropdown [settings]="dropdownSettings_referral" [placeholder]="'Select'"
                      (onDeSelect)="onHospDeSelect($event)" (onSelect)="onHospChange($event)"
                      [(ngModel)]="selectedRefHp" [data]="refHospListNew" formControlName="referral_hospital">
                    </ng-multiselect-dropdown>
                  

                  </div>

                </div> -->

                <div hidden>
                  <div class="form-group">
                    <!-- <button type="button" class="btn btn-sm btn-dark" (click)="onPreview($event)"><i
                        class="fa fa-prescription"></i>&nbsp;Preview Prescription</button>&nbsp; -->
                    <button type="button" id="btnPreviewModal" data-toggle="modal"
                      data-target="#exampleModal_1"></button>
                    <button type="button" id="btncontinueModal" data-toggle="modal"
                      data-target="#continue"></button>
                  </div>
                </div>


              </div>
              <!-- DRUGS END -->

              </div>

              <div class="col-xl-6 mb-3 mt-4" *ngIf="enableHumanMMU">
                <div class="cards mr-3 shadow-sm" style="border-radius: 1rem;">
                  <h5 class="card-header">Drugs</h5>
                  <div class="card-body">
                    <div class="form-group">
                      <label for="inputEmail4">Drug Type
                        <!-- <a role="button" style="cursor: pointer;" (click)="LoadMO('DN')" *ngIf="moreDN"
                          class="ml-5"><b>{{txtMoreDN}}</b></a> -->
                      </label>
                      <button type="button" class="btn btn-primary btn-sm float-right mb-1" (click)="addRowMMU()">Add Direction</button>
                      <div>
                        <ng-multiselect-dropdown [settings]="drugSettingsDrug" id="" [placeholder]="'Select'"
                           (onSelect)="onDrgSlctMMU($event, 'dt')"
                          (onDeSelect)="onDrgDeSlctMMU('dt')" [data]="drugtypesListMMU" [(ngModel)]="dTMMU"
                          [ngModelOptions]="{standalone: true}">
                        </ng-multiselect-dropdown>
                      </div>
                    </div>
                    <div>
                      <div class="form-group">
                        <label for="inputPassword4">Drug Name</label>
                        <div>
          
                          <ng-multiselect-dropdown [settings]="drugNameSettings" [placeholder]="'Select'"
                            (onSelect)="onDrgSlctMMU($event, 'dn')" 
                            [data]="drug_listMMU" (onDeSelect)="onDrgDeSlctMMU('dn')" [(ngModel)]="dNMMU"
                            [ngModelOptions]="{standalone: true}" >
                          </ng-multiselect-dropdown>
                          
                        </div>
                      </div>
                      <div class="form-group" *ngIf="!hideOtherDrugLabel">
                        <label for="inputPassword4">Other Drug Name</label>
                        <div>
                          <input type="text" autocomplete="off" [formControl]="pocForm.get('drugs.otherDrug')"
                            id="otherDrug" (keyup)="keyUp('otherDrug')" maxlength="100"
                            [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.otherDrug').errors }"
                            class="form-control form-control-sm  text-uppercase">
                        </div>
    
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 mb-3">
                
                <!-- Investigations start  -->
                <div class="cards h-100 mt-4 mr-3 shadow-sm" style="border-radius: 1rem;">
                  <h5 class="card-header">Investigations</h5>
                  <div class="card-body">
  
                    <div formGroupName="investigation">
                      <div class="form-group">
                        <label for="inputEmail4">Diagnostic Investigations
                          <a role="button" style="cursor: pointer;" (click)="LoadMO('IN')" *ngIf="moreIN"
                            class="ml-5"><b>{{txtMoreIN}}</b></a>
                        </label>
                        <div tabindex="0" class="">
                          <!-- (onDeSelectAll)="onItemDeSelectAllInvestgations($event)"
                          (onSelectAll)="onSelectAllInvestgations($event)"  -->
                          <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Select'"
                            [(ngModel)]="selectedItemsinvestgations"  (onSelect)="onItemSelectInvestgations($event)"
                            (onDeSelect)="onItemDeSelectInvestgations($event)" [ngModelOptions]="{standalone: true}"
                            [data]="investigationsList" [formControl]="pocForm.get('investigation.master')">
                          </ng-multiselect-dropdown>
                          <!-- <select formControlName="master" id="master"
                            [ngClass]="{ 'is-invalid': submitted && pocForm.get('investigation.master').errors }"
                            class="form-control form-control-sm ">
                            <option value="">Select</option>
                            <option *ngFor="let item of investigationsList" [value]="item.id">
                              {{item.investigation}}</option>
                          </select> -->
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputPassword4">Other Investigations</label>
                        <div>
                          <textarea rows="3" class="form-control form-control-sm  text-uppercase" 
                          formControlName="otherInvestigation" [ngClass]="{ 'is-invalid': submitted && pocForm.get('investigation.otherInvestigation').errors }">
                    </textarea>
                          <!-- <input type="text" autocomplete="off" formControlName="otherInvestigation"
                            id="otherInvestigation" (keyup)="keyUp('otherInvestigation')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                            (event.charCode == 40) ||(event.charCode == 41)|| (event.charCode == 58) ||(event.charCode == 63)|| (event.charCode == 64)
                            (event.charCode == 45) ||(event.charCode == 95)|| (event.charCode == 37) ||(event.charCode == 38)||(event.charCode == 42) ||
                         (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)' maxlength="100"
                            class="form-control form-control-sm  text-uppercase"
                            [ngClass]="{ 'is-invalid': submitted && pocForm.get('investigation.otherInvestigation').errors }"> -->
                        </div>
                      </div>
                    </div>
  
  
                  </div>
                </div>
                <!-- Investigations end  -->
                  </div>


              <div class="col-xl-12 mb-1 mt-2">
                <div class="row">
                  <div class="col-xl-12">

                    <br>
                    <div class="card shadow-sm" style="border-radius: 1rem;"
                      *ngIf="getRowFormControls.controls.length > 0">
                      <!-- <h5 class="card-header"></h5> -->
                      <div class="card-body pt-1 bg-white pt-3">
                        <div class="table-responsive">
                          <table class="table table-sm table-bordered w-100 text-left">
                            <thead style="background-color: rgb(28 173 199) !important;
                            color: white !important;">

                              <tr>
                                <th class="text-center">Medicines</th>
                                <th class="text-center">Duration</th>
                                <th class="text-center">Unit(Dosage)</th>
                                <th class="text-center">Relation with food</th>
                                <th class="text-center">Period</th>
                                <!-- <th class="text-center">&nbsp;</th> -->
                                <th class="text-center" colspan="2">Remarks</th>
                              </tr>

                            </thead>
                            <tbody>
                              <tr formArrayName="prescribed_medications"
                                *ngFor="let group of getRowFormControls.controls ; let i=index">
                                <ng-container [formGroupName]="i">

                                  <td>

                                    <div style="width:13rem !important;" *ngIf="!isFeature">
                                      <p class="mb-0" style="white-space: pre-wrap !important;"> <span
                                          class="text-danger" *ngIf="group.get('agentStock').value==''">*</span>
                                        {{group.get('name').value}} -
                                        {{group.get('agentStock').value==""?'0':group.get('agentStock').value}}
                                      </p>
                                    </div>
                                    <div style="width:13rem !important;" *ngIf="isFeature">
                                      <p class="mb-0" style="white-space: pre-wrap !important;"> <span
                                          class="text-danger">*</span>
                                        {{group.get('name').value}} -{{pack_quantity}}
                                        <!-- {{group.get('agentStock').value==""?'0':group.get('agentStock').value}} -->
                                      </p>
                                    </div>
                                    <!-- <p class="mb-0">{{group.get('name').value}}</p> -->

                                  </td>
                                  <td>


                                    <div>
                                      <div class="custom-control-inline custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" 
                                          [id]="'mcheckbox'+(i+1)" formControlName="mrng" (change)="onCheckbox(i)"
                                          [ngClass]="{ 'is-invalid': submitted && group.get('mrng').errors }">
                                        <label class="custom-control-label" [for]="'mcheckbox'+(i+1)">M</label>
                                      </div>
                                      <div class="custom-control-inline custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox"
                                          [id]="'acheckbox'+(i+1)" formControlName="aftr" (change)="onCheckbox(i)"
                                          [ngClass]="{ 'is-invalid': submitted && group.get('mrng').errors }">
                                        <label class="custom-control-label" [for]="'acheckbox'+(i+1)">A</label>
                                      </div>
                                    </div>
                                    <div>
                                      <div class="custom-control-inline custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" 
                                          [id]="'echeckbox'+(i+1)" formControlName="evng" (change)="onCheckbox(i)"
                                          [ngClass]="{ 'is-invalid': submitted && group.get('mrng').errors }">
                                        <label class="custom-control-label" [for]="'echeckbox'+(i+1)">E</label>
                                      </div>
                                      <div style="padding-left:36px !important;" class="custom-control-inline custom-control custom-checkbox">
                                       <input class="custom-control-input" type="checkbox" 
                                          [id]="'ncheckbox'+(i+1)" formControlName="night"
                                          (change)="onCheckbox(i)"
                                          [ngClass]="{ 'is-invalid': submitted && group.get('mrng').errors }">
                                        <label class="custom-control-label" [for]="'ncheckbox'+(i+1)">N</label>
                                      </div>
                                      <!-- new line added for the SOS 09-08-2022 -->
                                      <br>
                                      <div class="custom-control-inline custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" 
                                          [id]="'scheckbox'+(i+1)" formControlName="sos" (change)="onCheckbox(i)"
                                          [ngClass]="{ 'is-invalid': submitted && group.get('mrng').errors }">
                                        <label class="custom-control-label" [for]="'scheckbox'+(i+1)">SOS</label>
                                      </div>
                                      <!-- new lines ended -->
                                    </div>


                                  </td>
                                  <td>
                                    <div>

                                      <div class="form-inline">
                                        <div class="form-group">
                                          <input type="text" class="form-control form-control-sm" maxlength="20"
                                            formControlName="dosage" placeholder=""
                                            (change)="onValChng(i, $event.target.value, 'dosage')"
                                            [ngClass]="{ 'is-invalid': submitted && group.get('dosage').errors }"
                                            style="width:5rem !important;">&nbsp;
                                          <!-- onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                                            (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57)||
                                            (event.charCode == 32  || (event.charCode == 44)))' -->
                                          <!-- Ml -->
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="">
                                    <div>

                                      <div class="" style="width:9rem;">
                                        <div class=" custom-control custom-radio eRdoBtn">
                                          <input class="custom-control-input" type="radio" [id]="'bradio'+(i+1)"
                                            formControlName="relfood" value="Before" 
                                            [ngClass]="{ 'is-invalid': submitted && group.get('relfood').errors }">
                                          <label class="custom-control-label"
                                            [for]="'bradio'+(i+1)">Before</label>
                                        </div>
                                        <div class=" custom-control custom-radio eRdoBtn">
                                          <input class="custom-control-input " type="radio" [id]="'aradio'+(i+1)"
                                            formControlName="relfood" value="After"
                                            [ngClass]="{ 'is-invalid': submitted && group.get('relfood').errors }">
                                          <label class="custom-control-label" [for]="'aradio'+(i+1)">After</label>
                                        </div>
                                        <div class="custom-control custom-radio eRdoBtn">
                                          <input class="custom-control-input" type="radio" [id]="'anyradio'+(i+1)"
                                            formControlName="relfood" value="Anytime"
                                            [ngClass]="{ 'is-invalid': submitted && group.get('relfood').errors }">
                                          <label class="custom-control-label"
                                            [for]="'anyradio'+(i+1)">Anytime</label>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>

                                      <div class="form-group">
                                        <select formControlName="period" id="period"  style="width:7rem !important;"
                                          (change)="onRowDDChange(i,$event.target.value)"
                                          [ngClass]="{ 'is-invalid': submitted && group.get('period').errors }"
                                          class="form-control form-control-sm " #Periodvalue>
                                          <option value="">Select</option>
                                          <option value="Days">Days</option>
                                          <option value="Weeks">Weeks</option>
                                          <option value="Months">Months</option>
                                          <option value="Years">Years</option>
                                        </select>
                                        <div *ngIf="submitted && group.get('period').errors"
                                          class="invalid-feedback">
                                          <div *ngIf="group.get('period').errors.required">
                                            <!-- Period is required -->
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <input  style="width:7rem !important;" type="text"  placeholder={{placeHolders[i]}}
                                        class="form-control form-control-sm " formControlName="count"
                                        [ngClass]="{ 'is-invalid': submitted && group.get('count').errors }"
                                        (change)="onValChng(i, $event.target.value, 'count')"
                                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57) '>
                                    </div>
                                  </td>
                                
                                  <td style="width:10%">
                                    <textarea formControlName="remarks" rows="1" id="remarks" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                                        (event.charCode == 32 || event.charCode == 46))'
                                      (keyup)="keyUp('remarks')" class="form-control form-control-sm"
                                      style="resize: none;">
                                      </textarea>
                                  </td>
                                  <td style="width:5%;">
                                    <button (click)="deleteRow(i)" title="Delete" class="btn btn-sm btn-block ">
                                      <i class="fa fa-trash text-danger"></i></button>
                                  </td>
                                </ng-container>

                            </tbody>





                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            
              <div class="col-xl-6 mb-3" *ngIf="isLabPrefered || ispharmacyprefered">
                   <!--LAB-->
          
                   <div class="cards h-100 mt-4 mr-3 shadow-sm" style="border-radius: 1rem;">
                    <h5 class="card-header">LAB And Pharmacy</h5>
                    <div class="card-body">
                      <!-- <div *ngIf="appSrce==dipl">
                        <div class="row">
                          <div class="form-group col-md-4">
                            <label for="inputPassword4">State</label>
                            <div>
                              <select class="form-control" id="labStateId"
                                (change)="LoadRegionsbyStateId($event.target.value)">
                                <option value="">Select</option>
                                <option *ngFor="let st of lstStates" [value]="st.id">{{st.state_name}}</option>
                              </select>
                            </div>
                          </div> 
                           <div class="form-group col-md-4">
                            <label for="inputPassword4">Region</label>
                            <div>
                              <select class="form-control" id="labRegnId"
                                (change)="LoadDistbyRegion($event.target.value)">
                                <option value="">Select</option>
                                <option *ngFor="let rgn of lstRegns" [value]="rgn.id">{{rgn.region_name}}</option>
                              </select>
                            </div>
                          </div>
                           <div class="form-group col-md-4">
                            <label for="inputPassword4">District</label>
                            <div>
                              <select class="form-control" id="labDistId"
                                (change)="LoadLabPharmabyDist($event.target.value)">
                                <option value="">Select</option>
                                <option *ngFor="let lstDis of lstDist" [value]="lstDis.id">{{lstDis.district_name}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div *ngIf="appSrce==dipl">
                        <div class="row">
                          <div class="form-group col-md-4 mb-0" *ngIf="isLabPrefered">
                            <label for="inputPassword4">Lab Preferred</label>
                            <div>
                              <select class="form-control form-control-sm " id="labLabs" formControlName="lab_id"
                                (change)="onLabsChng($event.target.value)">
                                <option value="">Select</option>
                                <option *ngFor="let lab of lstTelgLab" [value]="lab.id">{{lab.lab_name}}</option>
                              </select>

                            </div>
                          </div>

                          <div class="form-group col-md-4 mb-0"  *ngIf="ispharmacyprefered">
                            <label for="inputPassword4">Pharmacy Preferred</label>
                            <div>
                              <select class="form-control form-control-sm" id="labPhrm" formControlName="pharmacy_id"
                                (change)="onPhrmcChng($event.target.value)">
                                <option value="">Select</option>
                                <option *ngFor="let phrm of lstTelgPhrm" [value]="phrm.id">{{phrm.pharmacy_name}}
                                </option>
                              </select>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div >
                        <!-- <div class="row">
                          <div class="form-group col-md-4 mb-0" *ngIf="isLabPrefered">
                            <label for="inputPassword4">Lab Preferred</label>
                            <div>
                              <select formControlName="lab_id" id="lab" class="form-control form-control-sm">
                                <option value="">Select</option>
                                <option *ngFor="let lab of lstLabs" [value]="lab.id">{{lab.lab_name}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="form-group col-md-4 mb-0" *ngIf="ispharmacyprefered">
                            <label for="inputPassword4">Pharmacy Preferred</label>
                            <div>
                              <select formControlName="pharmacy_id" id="phrmcy" class="form-control form-control-sm">
                                <option value="">Select</option>
                                <option *ngFor="let phrm of lstPhmcy" [value]="phrm.id">{{phrm.pharmacy_name}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div> -->
                      </div>
     
     
                    </div>
                  </div>
                   <!--LAB END-->
              </div>
              <div class="col-xl-6 mb-3">
                  <!-- type of consultation start  -->
            <div class="cards h-100 mt-4 mr-3 shadow-sm" style="border-radius: 1rem;">
             <h5 class="card-header">Instructions</h5> 
              <div class="card-body">
                
            <div *ngIf="enableConsultationTypeInPOC" class="p-2">
              <div class="form-group ">
                <label for="">Type Of Consultation<span class="text-danger">*</span></label>
                <select [formControl]="pocForm.get('type_of_consultation')"
                class="form-control form-control-sm " id="type_of_consultation"
                [ngClass]="{ 'is-invalid': submitted && f.type_of_consultation.errors }">
                  <option value="">--Select--</option>
                  
                  <option *ngFor="let item of ConsultationList" [value]="item.consultationType">
                    {{item.consultationType}}</option>
                </select>
                <div *ngIf="submitted && f.type_of_consultation.errors" class="invalid-feedback">
                  <div *ngIf="f.type_of_consultation.errors.required">Type Of Consultation is required</div>
              </div>
              </div>
            </div>
            <div class="row px-2">
              <!-- Follow up Date start -->
              <div class="col-xl-6">
                <div class="form-group" formGroupName="advice">
                  <label for="inputEmail4">Follow up Date</label>
                  <div>
                    <input type="text" autocomplete="off" formControlName="followupDate" id="followupDate"
                      placeholder="Follow up Date" bsDatepicker [minDate]="minDate" #dp="bsDatepicker"
                      (focus)="dp.show()"
                      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false,adaptivePosition: true,isAnimated: true }"
                      [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.followupDate').errors }"
                      class="form-control form-control-sm ">
                  </div>
                </div>
              </div>
               <!-- Follow up Date end -->
               <!-- checkbox -->
             <div class="col-xl-6 pt-4">
              
              <div class="form-group form-check mr-auto" #myDiv>
                <input type="checkbox" name="checkbox" [(ngModel)]="isPcChecked"
                  [ngModelOptions]="{standalone: true}" (click)="onPhysicalConsultation($event)">
                <label  class="form-check-label ml-2" for="exampleCheck1" >Require Physical consultation
                </label>
              </div>
            </div>
          
            <!--/ checkbox END-->
            </div>


            <div *ngIf="isUKTReferralEnable" class="p-2">

              <div class="form-group" *ngIf="!refdivshow">
                <label for="">Type Of Referral Hospital</label>
                <select class="form-control form-control-sm" (change)="onHospTypeChange($event.target.value)"
                  class="form-control form-control-sm ">
                  <option value="">Select</option>
                  <option *ngFor="let item of HospTypeList" [value]="item.id">{{item.hospital_type}}
                  </option>

                </select>
              </div>
              <div class="form-group" *ngIf="!refdivshow && refHospListNew">
                <label for="">Referral Hospital</label>
                <ng-multiselect-dropdown [settings]="dropdownSettings_referral" [placeholder]="'Select'"
                  (onDeSelect)="onHospDeSelect($event)" (onSelect)="onHospChange($event)"
                  [(ngModel)]="selectedRefHp" [data]="refHospListNew" formControlName="referral_hospital">
                </ng-multiselect-dropdown>

              </div>

            </div>
            <div *ngIf="isReferralEnable" class="p-2">

              <div class="form-group">
                <label for="">Type Of Referral Hospital</label>
                <select class="form-control form-control-sm" (change)="getReferralHospitalsMMU($event.target.value)"
                  class="form-control form-control-sm ">
                  <option value="">Select</option>
                  <option *ngFor="let item of HospTypeList" [value]="item.id">{{item.hospital_type}}
                  </option>

                </select>
              </div>
              <div class="form-group">
                <label for="">Referral Hospital</label>
                <select class="form-control form-control-sm" formControlName="refer_to_hospital_id" (change)="referralReasonList()">
                  <option value="">Select</option>
                  <option *ngFor="let item of refHospListNewMMU" [value]="item.id">{{item.hospital_name}}
                  </option>
                </select>
                <!-- -->

              </div>
              <div class="form-group">
                <label for="">Referral Reason</label>
                <select class="form-control form-control-sm" [(ngModel)]="referral_reason" [ngModelOptions]="{standalone: true}">
                  <option value="">Select</option>
                  <option *ngFor="let item of reasonList" [value]="item.referral_reason">{{item.referral_reason}}
                  </option>
                </select>
                <!-- -->

              </div>
              <div class="form-group" *ngIf="referral_reason == 'Other'">
                <label for="">Other Reasons</label>
                <input type="text" formControlName="referral_reason" class="form-control form-control-sm">

              </div>
              <div class="form-group">
                <label for="">Referral Remarks</label>
                <input type="text" formControlName="referral_remarks" class="form-control form-control-sm">

              </div>

            </div>

            <!-- for all doctors  -->
            <!--  -->
            <div *ngIf="HimsReferral" class="p-2">

              <div class="form-group">
                <label for="">HIMS Referral Hospital</label>
                <select class="form-control form-control-sm"  formControlName="referral_center_id" (change)="onReferral($event.target.value)"
                  class="form-control form-control-sm ">
                  <option value="">Select</option>
                  <option *ngFor="let item of referralHospTypeList" [value]="item.id">{{item.centerName}}
                  </option>

                </select>
              </div>
              <!-- <div class="form-group">
                <label for="">Referral Hospital</label>
                <ng-multiselect-dropdown [settings]="dropdownSettings_referral" [placeholder]="'Select'"
                  (onDeSelect)="onHospDeSelect($event)" (onSelect)="onHospChange($event)"
                  [(ngModel)]="selectedRefHp" [data]="refHospListNew" formControlName="referral_hospital">
                </ng-multiselect-dropdown> -->
                <!-- -->

              <!-- </div> -->

            </div>

            <div class="p-2">
              <div class="form-group">
                <label for="inputPassword4">Instructions</label>
                <div>
                  <textarea rows="3"  class="form-control form-control-sm  text-uppercase" style="resize: none;"
                  formControlName="instructions"  [maxlength]="maxChars">
            </textarea>
                  
                  <!-- <textarea id="instructions" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                    (event.charCode == 40) ||(event.charCode == 41)|| (event.charCode == 58) ||(event.charCode == 63)|| (event.charCode == 64) ||
                    (event.charCode == 45) ||(event.charCode == 95)|| (event.charCode == 37) ||(event.charCode == 38)||(event.charCode == 42) ||
                 ((event.charCode >= 97 && event.charCode <= 122)) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)' class="form-control form-control-sm"
                    formControlName="instructions" [maxlength]="maxChars" style="resize: none; height: 100px;;"></textarea> -->
                    
                </div>
              </div>
              <div class="form-group" *ngIf="refdivshow">
                <label for="inputPassword4">Procedure</label>
                <div>
                  <!-- <textarea id="procedurevalue" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                      (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                      (event.charCode == 32 || event.charCode == 46))'
                      class="form-control form-control-sm "
                      style="resize: none; height: 100px;">
                    </textarea> -->
                  <textarea rows="5" cols="50" wrap="physical" class="form-control form-control-sm " style="height: 100px;"
                    (blur)="onProcedure()" name="comments" id="procedurevalue" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                      (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                      (event.charCode == 32 || event.charCode == 46))'></textarea>
                </div>
              </div>
              <div class="form-group " *ngIf="refdivshow" style="margin-top: 30px;">
                <label for="inputPassword4">Doctor Name</label>
                <div>
                  <input type="text" class="form-control form-control-sm" id="refdoctorName" style="height: 33px">
                </div>
              </div>
              <div class="form-group " *ngIf="refdivshow" style="margin-top: 30px;">
                <label for="inputPassword4">Status</label>
                <div>
                  <select id="statusvalue" formControlName="refstatus"
                    (change)="onRefStatusChange($event.target.value)" class="form-control form-control-sm ">
                    <option value="">Select</option>
                    <option *ngFor="let sts of statusget" [value]="sts.id">
                      {{sts.referral_type}}</option>
                  </select>
                </div>
              </div>

              <!-- <div class="form-group">
                  <button type="button" class="btn btn-sm btn-dark" (click)="onPreview($event)"><i
                      class="fa fa-prescription"></i>&nbsp;Preview Prescription</button>&nbsp;
                </div> -->
            </div>
            <div hidden>
              <div class="form-group">
                <!-- <button type="button" class="btn btn-sm btn-dark" (click)="onPreview($event)"><i
                    class="fa fa-prescription"></i>&nbsp;Preview Prescription</button>&nbsp; -->
                <button type="button" id="btnPreviewModal" data-toggle="modal"
                  data-target="#exampleModal_1"></button>
                <button type="button" id="btncontinueModal" data-toggle="modal"
                  data-target="#continue"></button>
              </div>
            </div>
            
              </div>
            </div>
            <!-- type of consultation end  -->
              </div>
            </div>

          </div>
          <!-- new lines added for created on flag 30-06-2023 -->
          <div class="form-group col-md-3 col-sm-12 col-12 mt-3" *ngIf="showCreatedOn">
            <label class="control-label">Created Date </label>
            <div>
                <input type="text" autocomplete="off" formControlName="created_on" id="created_on" 
                    bsDatepicker #dob="bsDatepicker" class="form-control form-control-sm form-control form-control-sm-sm" 
                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false,adaptivePosition: true,isAnimated: true }">
            </div>
        </div>
          <!-- new mom world banck changes end 15-02-2023 -->
          <div div class="mt-4 mb-4 mr-3 text-right">
            <button type="button" class="btn btn-Preview btn-emg font-weight-bold"
                    (click)="gotoConsultation()">
                    <!-- <svg width="18" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.75 3C5.02065 3 4.32118 3.28973 3.80546 3.80546C3.28973 4.32118 3 5.02065 3 5.75V18.25C3 18.9793 3.28973 19.6788 3.80546 20.1945C4.32118 20.7103 5.02065 21 5.75 21H18.25C18.9793 21 19.6788 20.7103 20.1945 20.1945C20.7103 19.6788 21 18.9793 21 18.25V5.75C21 5.02065 20.7103 4.32118 20.1945 3.80546C19.6788 3.28973 18.9793 3 18.25 3H5.75ZM4.5 5.75C4.5 5.06 5.06 4.5 5.75 4.5H18.25C18.94 4.5 19.5 5.06 19.5 5.75V18.25C19.5 18.94 18.94 19.5 18.25 19.5H5.75C5.06 19.5 4.5 18.94 4.5 18.25V5.75ZM7.5 10.75C7.5 10.5511 7.57902 10.3603 7.71967 10.2197C7.86032 10.079 8.05109 10 8.25 10C8.44891 10 8.63968 10.079 8.78033 10.2197C8.92098 10.3603 9 10.5511 9 10.75C9 10.9489 8.92098 11.1397 8.78033 11.2803C8.63968 11.421 8.44891 11.5 8.25 11.5C8.05109 11.5 7.86032 11.421 7.71967 11.2803C7.57902 11.1397 7.5 10.9489 7.5 10.75ZM8.25 8.5C7.65326 8.5 7.08097 8.73705 6.65901 9.15901C6.23705 9.58097 6 10.1533 6 10.75C6 11.3467 6.23705 11.919 6.65901 12.341C7.08097 12.7629 7.65326 13 8.25 13C8.84674 13 9.41903 12.7629 9.84099 12.341C10.2629 11.919 10.5 11.3467 10.5 10.75C10.5 10.1533 10.2629 9.58097 9.84099 9.15901C9.41903 8.73705 8.84674 8.5 8.25 8.5ZM8.25 15.5C8.05109 15.5 7.86032 15.579 7.71967 15.7197C7.57902 15.8603 7.5 16.0511 7.5 16.25C7.5 16.4489 7.57902 16.6397 7.71967 16.7803C7.86032 16.921 8.05109 17 8.25 17C8.44891 17 8.63968 16.921 8.78033 16.7803C8.92098 16.6397 9 16.4489 9 16.25C9 16.0511 8.92098 15.8603 8.78033 15.7197C8.63968 15.579 8.44891 15.5 8.25 15.5ZM6 16.25C6 15.9545 6.0582 15.6619 6.17127 15.389C6.28434 15.116 6.45008 14.8679 6.65901 14.659C6.86794 14.4501 7.11598 14.2843 7.38896 14.1713C7.66194 14.0582 7.95453 14 8.25 14C8.54547 14 8.83806 14.0582 9.11104 14.1713C9.38402 14.2843 9.63206 14.4501 9.84099 14.659C10.0499 14.8679 10.2157 15.116 10.3287 15.389C10.4418 15.6619 10.5 15.9545 10.5 16.25C10.5 16.8467 10.2629 17.419 9.84099 17.841C9.41903 18.2629 8.84674 18.5 8.25 18.5C7.65326 18.5 7.08097 18.2629 6.65901 17.841C6.23705 17.419 6 16.8467 6 16.25ZM12.25 10C12.0511 10 11.8603 10.079 11.7197 10.2197C11.579 10.3603 11.5 10.5511 11.5 10.75C11.5 10.9489 11.579 11.1397 11.7197 11.2803C11.8603 11.421 12.0511 11.5 12.25 11.5H17.25C17.4489 11.5 17.6397 11.421 17.7803 11.2803C17.921 11.1397 18 10.9489 18 10.75C18 10.5511 17.921 10.3603 17.7803 10.2197C17.6397 10.079 17.4489 10 17.25 10H12.25ZM11.5 16.25C11.5 16.0511 11.579 15.8603 11.7197 15.7197C11.8603 15.579 12.0511 15.5 12.25 15.5H17.25C17.4489 15.5 17.6397 15.579 17.7803 15.7197C17.921 15.8603 18 16.0511 18 16.25C18 16.4489 17.921 16.6397 17.7803 16.7803C17.6397 16.921 17.4489 17 17.25 17H12.25C12.0511 17 11.8603 16.921 11.7197 16.7803C11.579 16.6397 11.5 16.4489 11.5 16.25ZM6.75 6C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5H17.25C17.4489 7.5 17.6397 7.42098 17.7803 7.28033C17.921 7.13968 18 6.94891 18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H6.75Z"
                        fill="white" />
                    </svg> -->
                    <!-- <i class="fa fa-times"></i>&nbsp; -->
  
                    Cancel POC
                  </button> &nbsp;
            <button type="button" class="btn btn-Preview btn-lg btn-sm" (click)="onPreview($event)">Preview Prescription</button>

          </div>
          
        </form>


        <!--Digital Preciption Tab-->
        <div class="tbs-menu" *ngIf="pocForm.get('is_epaper').value">
          <div class="patient" id="patient-tbs">
            <ul class="nav nav-pills nav-pills1 " id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="nav-link active " id="digital-prescription" data-toggle="pill" href="#digital-prescription"
                  role="tab" aria-controls="pills-home" aria-selected="true">Digital Prescription</a>
              </li>

            </ul>
            <hr class="mb-2 mt-0 mb-3">
          </div>
        </div>



        <div class="patient " id="" *ngIf="pocForm.get('is_epaper').value">
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="digital-prescription" role="tabpanel"
              aria-labelledby="digital-prescription">
              <div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="cards h-100">
                      <div class="card-header"><strong> Digital Prescription </strong></div>
                      <div class="card-body">
                        <div class="form-row small">
                          <div class="form-group col-md-4">
                            <div class="custom-control-inline custom-control custom-radio eRdoBtn">
                              <input class="custom-control-input" type="radio" id="isUpld" value="Upload"
                                (change)="isDgtl='Upload';isPrvwHdn=true" [checked]="isDgtl=='Upload'">
                              <label class="custom-control-label" for="isUpld">File Upload</label>
                            </div>
                            <div class="custom-control-inline custom-control custom-radio eRdoBtn">
                              <input class="custom-control-input" type="radio" id="isCmra" value="Camera"
                                (change)="isDgtl='Camera';isPrvwHdn=true" [checked]="isDgtl=='Camera'">
                              <label class="custom-control-label" for="isCmra">Image Capture</label>
                            </div>
                          </div>
                          <div class="form-group col-md-4">
                            <div class="custom-file" *ngIf="isDgtl=='Upload'">
                              <!-- <div class="col-xl-11 col-1"> -->
                              <input type="file" class="custom-file-input" id="dgtlPres" (change)="onFile($event)"
                                accept="image/jpeg,image/jpg,image/png" #dgtlPres>
                              <label class="custom-file-label " for="dgtlPres">Digital Prescription</label>
                              <span class="text-primary" *ngIf="false">Dimensions should be 300(w) *
                                80(h)</span>&nbsp;
                              <!-- </div>
                                  <div class="col-xl-1 col-1"> -->
                              File format should be jpg/jpeg/png&nbsp;&nbsp;&nbsp;<br />
                              <span *ngIf="dgtlFile">
                                <span *ngIf="upldFile!=''">
                                  <a href="javascript:void(0)" class="fa fa-eye" title="View File"
                                    (click)="viewFile()" *ngIf="upldFile!=''"><i class=""></i>&nbsp;{{upldFile}}</a>
                                </span>
                              </span>
                              <!-- </div> -->
                            </div>
                          </div>
                          <div class="form-group col-md-4" style="padding-top: 0.2%;" *ngIf="isDgtl=='Upload'">
                            <button type="button" class="btn btn-sm btn-primary" (click)="uploadImg()"
                              [disabled]="!(dgtlFile!=undefined && dgtlFile!=null && upldFile!='')">Upload &
                              Save</button>&nbsp;&nbsp;&nbsp;
                            <button class="btn btn-sm btn-danger" (click)="upldFile=''">Clear</button>
                          </div>
                        </div>
                        <!-- <div class="form-row small" [hidden]="isDgtl!='Camera'">         
                          <div class="form-group col-md-4" style="text-align: center;"><span></span></div>              
                          <div class="form-group col-md-4" style="text-align: center; padding-left: 10%;" *ngIf="webcamImage">
                            <span><strong>Preview</strong></span>
                          </div>              
                        </div> -->
                        <div class="row" [hidden]="isDgtl!='Camera'">
                          <div class="col-xl-6 h-100">
                            <strong>Camera</strong>
                            <div class="img-fluid text1">
                              <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                                *ngIf="isDgtl=='Camera'" [allowCameraSwitch]="allowCameraSwitch"
                                [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" [imageQuality]="1"
                                (cameraSwitched)="cameraWasSwitched($event)" (initError)="handleInitError($event)"
                                style="max-width: 100%; height:auto"></webcam>
                            </div>
                            <div class="mt-1 text-center">
                              <button class="btn btn-sm btn-orange"
                                (click)="triggerSnapshot();isPrvwHdn=false">Freeze</button>
                            </div>
                          </div>
                          <div class="col-xl-6 h-100" [hidden]="isPrvwHdn">
                            <strong>Preview</strong>
                            <div class="snapshot" *ngIf="webcamImage">
                              <img [src]="webcamImage.imageAsDataUrl" class="img-fluid" />
                              <div class="mt-1 text-center">
                                <button *ngIf="webcamImage" class="btn btn-sm btn-success"
                                  (click)="uploadImg()">Upload
                                  &
                                  Save</button> &nbsp;
                                <button *ngIf="webcamImage" class="btn btn-sm btn-danger"
                                  (click)="webcamImage=null">Clear</button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="form-row small" [hidden]="isDgtl!='Camera'">             
                          <div class="form-group col-md-4">                
                          </div>     
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
    </div>

  </div>

</main>
<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Prescription</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-sm small">
          <tr class="active bg-light">
            <td colspan="4">
              <h6>Patient Details</h6>
            </td>
          </tr>
          <tr>
            <td><strong>Name</strong> </td>
            <td>{{benData?.first_name + ' '+ benData?.middle_name + ' ' + benData?.last_name}}</td>
            <td><strong>ID</strong></td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Phone Number</strong></td>
            <td>{{benData?.mobile}}</td>
            <td><strong>Age</strong></td>
            <td>{{benData?.age}}</td>
          </tr>
          <tr>
            <td><strong>Gender</strong></td>
            <td>{{benData?.gender_id == 1 ? 'Male' : 'Female'}}</td>
            <td><strong>Address</strong></td>
            <td>{{benData?.address}}</td>
          </tr>
          <tr>
            <td colspan="4" class="bg-light">
              <h6>Doctor Details</h6>
            </td>
          </tr>
        </table>
        <table class="table table-bordered table-sm small">
          <tr class="bg-light">
            <td class="active text-center" colspan="6">
              <h6>Prescription</h6>
            </td>
          </tr>
          <tr>
            <td colspan="3"><strong>Chief Complaints/ History of Present Illness:</strong></td>
            <td colspan="3">{{pocCc }}</td>
          </tr>
          <!-- <tr>
              <td colspan="3"><strong>Medical History:</strong></td>
              <td colspan="3">{{pocForm.get('medical_history.pastIllness').value + ',' + pocForm.get('medical_history.surgicalHistory').value}}</td>
            </tr> -->
          <tr>
            <td colspan="3"><strong>Vitals</strong></td>
            <td colspan="3">{{pocVitals}}</td>
          </tr>
          <tr>
            <td colspan="3"><strong>Past History & Allergies</strong></td>
            <td colspan="3">{{pocHistory}} </td>
          </tr>
          <tr>
            <td colspan="3"><strong>Provisional Diagnosis</strong> </td>
            <td colspan="3">{{provDgns}}</td><!-- <td colspan="3">{{pocCc}}</td> -->
          </tr>
          <tr>
            <td colspan="3"><strong>Investigations</strong></td>
            <td colspan="3">{{pocIn}}</td>
          </tr>
          <tr>
            <!-- Doctor Note  -->
            <td colspan="3"><strong> Doctor Note</strong></td>
            <td colspan="3">{{pocForm.get('advice.doctorComment').value}}</td>
          </tr>
          <tr>
            <th><strong>Drug Type</strong></th>
            <th>Drug Name</th>
            <th>Unit(Dosage)</th>
            <th>Direction</th>
            <th>Instruction</th>
            <th>No of Days</th>
          </tr>
          <tr>
            <td>{{pocDrug.drug_type}}</td>
            <td>{{pocDrug.drug_name}}</td>
            <td>{{pocDrug.dsg}}</td>
            <td>{{pocDrug.dir}}</td>
            <td>{{pocDrug.ins}}</td>
            <td>{{pocDrug.noofdays}}</td>
          </tr>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn  btn-sm btn-primary" (click)="onSubmit($event)">Submit</button>
      </div>
    </div>
  </div>
</div>
<!-- New Modal -->
<div class="modal fade" id="exampleModal_1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Prescription</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0">
        <table border="0" style="background-color:#f8f6f6;width:100%;">
          <tr>
            <td style="padding: 20px;">
              <table class="" border="0" cellpadding="4" cellspacing="4"
                style="width: 100%; font-size:14px; background-color: #f8f6f6; padding: 4px;"
                [ngStyle]="{ 'background': 'url(' + bg + ')', 'background-repeat': 'no-repeat', 'background-position': 'center', 'background-attachment': 'cover' }">
                <tr style="background-color:#f2f2f2;">
                  <td colspan="6">
                    <table border="0" style="width:100%;">
                      <tr>
                        <td><img src="../../../assets/images/prescription.png"></td>
                        <td valign="middle">
                          <address style="margin-bottom: 0px !important;"><small>
                              <strong>{{doc.first_name+ '' + doc.last_name}}</strong>
                              {{doc.qualification + ((doc.superspecialiy != undefined) ? ', ' + doc.superspecialiy : ''
                              )}}<br />
                              <strong>MCI Number :</strong>{{doc.mci}}<br />
                              {{doc.address}}
                            </small>
                          </address>
                        </td>
                        <td align="right"><img [src]="presLogo"></td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr style="height:2px;">
                  <td colspan="6"></td>
                </tr>
                <tr>
                  <td><strong>Name</strong> </td>
                  <td>{{benData?.first_name + '' + benData?.last_name}}</td>
                  <td><strong>ID</strong> </td>
                  <td>9247248376</td>
                  <td><strong>Phone Number </strong></td>
                  <td>{{benData?.mobile}}</td>
                </tr>
                <tr>
                  <td><strong>Age</strong> </td>
                  <td>{{benData?.age}}</td>
                  <td><strong>Gender</strong> </td>
                  <td>{{benData?.gender_id == 1 ? 'Male' : 'Female'}}</td>
                  <td><strong>Address</strong> </td>
                  <td>{{benData?.address}}</td>
                </tr>
                <tr>
                  <td colspan="6">
                    <hr style="border:1px solid #17c5bb">
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <table cellpadding="2">
                      <tbody>
                        <tr>
                          <td>
                            <h6 class="mb-0">Chief Complaints/ History of Present Illness: </h6>
                          </td>
                        </tr>
                        <tr>
                          <td>{{pocCc}} </td>
                        </tr>
                        <tr style="height: 5px;">
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <h6 class="mb-0">Vitals</h6>
                          </td>
                        </tr>
                        <tr>
                          <td> {{pocVitals}} </td>
                        </tr>
                        <tr style="height: 5px;">
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <h6 class="mb-0">Past History &amp; Allergies:</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>{{pocHistory}} </td>
                        </tr>
                        <tr style="height: 5px;">
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <h6 class="mb-0">Provisional Diagnosis </h6>
                          </td>
                        </tr>
                        <tr>
                          <td>{{provDgns}}</td>
                          <!-- <td> {{pocForm.get('diagnosis.provisionalDiagnosis').value}} </td> -->
                        </tr>
                        <tr style="height: 5px;">
                          <td></td>
                        </tr>
                        <!-- <tr><td><h6 class="mb-0">Investigations </h6></td></tr>
                          <tr><td>  CBP, SMEAR FOR MP, WIDAL</td></tr>
                          <tr style="height: 5px;"><td></td></tr> -->
                        <tr>
                          <td>
                            <h6 class="mb-0">Advice </h6>
                          </td>
                        </tr>
                        <tr>
                          <td>{{pocAdvice}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <table border="0" style="width:100%;" cellpadding="2">
                      <tbody>
                        <tr style="background-color: #17c5bb; color: #ffffff;">
                          <th>S.No</th>
                          <th>Drug Type</th>
                          <th>Drug Name</th>
                          <th>Dosage</th>
                          <th>Direction</th>
                          <th>Instructions</th>
                          <th>Period</th>
                        </tr>
                        <tr *ngFor="let item of getRowFormControls.value;let i=index;">
                          <td>{{(i+1)}}</td>
                          <td>{{item.type}}</td>
                          <td>{{item.name}}</td>
                          <td>{{item.dosage}}</td>
                          <td>{{(item.mrng==true?'X':'0')+' - '+(item.aftr==true?'X':'0')+' -
                            '+(item.evng==true?'X':'0')}}</td>
                          <td>{{item.relfood != 'Anytime' ? (item.relfood + ' Food') : item.relfood}}</td>
                          <td>{{item.count}}&nbsp;{{item.period}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <hr style="border:1px solid #17c5bb">
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <table cellpadding="2">
                      <tbody>
                        <tr>
                          <td colspan="2">
                            <h5>Lab Test</h5>
                          </td>
                        </tr>
                        <tr *ngFor="let item of pocForm.get('investigation.master').value;let i = index">
                          <td>{{i+1}}</td>
                          <td>{{item.investigation}} </td>
                        </tr>
                        <tr>
                          <td>
                            {{pocForm.get('investigation.otherInvestigation').value != '' ?
                            ((pocForm.get('investigation.master').value) != '' ?
                            ((pocForm.get('investigation.master').value).length + 1) : '1') : ''}}
                          </td>
                          <td>{{pocForm.get('investigation.otherInvestigation').value}}</td>
                        </tr>
                        <!-- <tr><td>2</td><td> Liver Function Test  </td></tr>
                    <tr><td>3</td><td> CBP </td></tr>
                    <tr><td>4</td><td> Liver Function Test  </td></tr> -->
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <table cellpadding="2">
                      <tbody>
                        <tr>
                          <td>
                            <h5>Follow Up</h5>
                          </td>
                        </tr>
                        <tr>
                          <td>{{pocForm.value.advice.followupDate | date :'dd-MM-yyyy HH:mm:ss'}} </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" align="center">
                    <hr style="border:1px solid #17c5bb; margin-bottom:0px;">
                    <small style="font-size: 10px; text-align: center;">Substitue medicine brand if above unavilble
                      unless Doctor Says not to</small>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <table border="0" style="width:100%; padding: 20px;">
                      <tr>
                        <td valign="middle" style="padding: 0px 20px;">

                          <img
                            src="data:image/png;base64,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"
                            width="100px">
                          <address><small>
                              <strong> Dr Sharanya Reddy</strong>
                            </small>
                          </address>
                        </td>
                        <td align="right" style="padding:0px 20px;"><img src="../../../assets/images/qrcode.png"
                            style="width:50px;"> <br />
                          For support please contact VIDMED:<br /> 040-66336663
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr style="background-color:#f2f2f2;">
            <td colspan="6" align="center">
              <hr style="border:1px solid #17c5bb; margin-bottom:0px;">
              <small style="font-size: 14px; text-align: center;">Vidmed Pharmacy Pharmacy, Ameerpet, Hyderabad,
                Telangana, Contact : 9849012835 </small>
            </td>
          </tr>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"
          id="prescriptionModalClose">Close</button>
        <button type="button" class="btn  btn-sm btn-primary" (click)="onSubmit($event)">Submit</button>
      </div>
    </div>
  </div>
</div>
<!-- Patient Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" style="z-index: 99999 !important;"
  id="patientModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Patient History</h5>
        <button type="button" id="patientHistoryButton" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-sm">
          <!-- <tr class="bg-light">
            <th colspan="4">Medications</th>
          </tr> -->
          <tr>
            <th>Date</th>
            <!-- <th>Medications Given</th> -->
            <th>Doctor Name</th>
            <th>Follow Up</th>
            <!-- <th>View File</th> -->
            <th>POC</th>
          </tr>
          <tr *ngFor="let item of benHistory">
            <td>{{item.visit_date | date : 'dd-MM-yyyy'}}</td>
            <td>
              {{item.doctor_id.first_name}} {{item.doctor_id.last_name}}
              <!-- <div *ngFor="let itm of item.prescribed_medications">
                {{itm.name}}
              </div> -->
            </td>
            <td>
              <div
                *ngIf="item.doctor_id?.first_name==docData?.first_name  || item.doctor_id?.first_name!=docData?.first_name && pocpatientHistory!=true "
                class="badge badge-primary badge-pill" title="Prescription" style="cursor: pointer;">
                <a (click)="followupclick(item)"> <i class="fa fa-edit text-white"></i></a>
              </div>
              <div *ngIf="item.doctor_id?.first_name!=docData?.first_name && pocpatientHistory==true"
                class="badge badge-pill" title="Prescription" style="background-color: #cfdcf1;">
                <a (click)="followupclick2()"> <i class="fa fa-edit text-white"></i></a>
              </div>
            </td>
            <td>
              <div
                *ngIf="item.doctor_id?.first_name==docData?.first_name  || item.doctor_id?.first_name!=docData?.first_name && pocpatientHistory!=true "
                class="badge badge-primary badge-pill" title="Prescription" style="cursor: pointer;">
                <a (click)="imgPath='';openpath(item)"> <i class="fa fa-eye text-white"></i></a> <!-- item -->
                <!-- openModal(item) -->
              </div>
              <div *ngIf="item.doctor_id?.first_name!=docData?.first_name && pocpatientHistory==true"
                class="badge badge-pill" title="Prescription" style="background-color: #cfdcf1;">
                <a (click)="imgPath='';followupclick2()"> <i class="fa fa-eye text-white"></i></a>

              </div>
            </td>

          </tr>
        </table>
        <table class="table table-bordered table-sm" style="display: none;">
          <tr class="bg-light">
            <th colspan="4">Diagnosis History</th>
          </tr>
          <tr>
            <th>Date</th>
            <th>Diagnosis</th>
            <th>Doctor Note</th>
            <th>View File</th>
          </tr>
          <tr>
          <tr *ngFor="let item of lstbenHstry">
            <!-- benHistory  -->
            <td>{{item.visit_date | date :'dd-MM-yyyy HH:mm:ss'}}</td>
            <td>{{item.dgns}}</td>
            <td>{{item.docCmnt}}</td>
            <td>
              <div class="badge badge-primary badge-pill" title="Prescription" style="cursor: pointer;">
                <a (click)="imgPath='';onViewPresOld(item)"> <i class="fa fa-eye text-white"></i></a> <!-- item -->
                <!-- openModal(item) -->
              </div>
            </td>
            <!-- <td>{{item.visit_date | date :'dd-MM-yyyy'}}</td>
            <td>{{item.diagnosis.provisionalDiagnois}}</td>
            <td>{{item.advice.doctorComment}}</td> -->
          </tr>
        </table>
        <table class="table table-bordered table-sm" style="display: none;">
          <tr class="bg-light">
            <th colspan="2">Lab Investigations </th>
          </tr>
          <tr>
            <th>Date</th>
            <th>Investigation</th>


          </tr>
          <tr *ngFor="let item of benHistory">
            <td>{{item.visit_date | date :'dd-MM-yyyy '}}</td>
            <td>
              <div *ngFor="let itm of item.investigation?.master">
                {{itm.investigation}}
              </div>
            </td>

          </tr>
        </table>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Alert -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" style="z-index: 99999 !important;"
  id="continue" role="dialog" aria-labelledby="edit" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"> Medicines are not specified, Do you want to continue?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm  btn-primary" data-dismiss="modal"
          (click)="yesContinue = true; openPrescriptionModal()" data-dismiss="modal">Yes</button>
        <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>
<!-- Emergency -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" style="z-index: 99999 !important;"
  id="emergencyModal" role="dialog" aria-labelledby="edit" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Do you want to Exit the Plan of Care ?</h5>
        <button type="button" id="buttonEmergency" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group ">
          <div class="col-md-12">
            <label>Comments</label>
            <textarea type="text" rows="5" class="form-control form-control-sm " [(ngModel)]="emergencyComment"> </textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm  btn-primary" data-dismiss="modal" (click)="emergencyExit()"
          data-dismiss="modal">Yes</button>
        <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>
<!-- Confirm Message for doctor to close the video call -->
<button type="button" class="d-none" data-toggle="modal" data-target="#confirmMessage" id="btnConfirmMessage"></button>
<div class="modal fade" data-backdrop="static" data-keyboard="false" id="confirmMessage" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Confirmation Message</h5>
        <button type="button" id="btnConfirmMessageClose" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Patient/Doctor/Health Care Worker has disconnected the video consultation,
        but still do you want to provide plan of care?
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-primary btn-sm" onclick="window.webComponent.style.display='none'" -->
        <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal">Yes</button>
        <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal"
          (click)="gotoConsultation()">No</button>
      </div>
    </div>
  </div>
</div>
<input type="button" (click)="chkTstrMsg()" id="eTest" hidden>
<input type="button" (click)="withOut_PrescriptionSumitted()" id="bntwithOut_Prescription" class="d-none">


<!--Audio Player-->
<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" style="z-index: 99999 !important;"
id="audioConsent" role="dialog" aria-labelledby="edit" aria-hidden="true">
<div class="modal-dialog">
<div class="modal-content" style="width:576px !important" >
  <div class="modal-header">
    <h5 class="modal-title">Audio Consent </h5>
    
    <button type="button" id="buttonEmergency" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
  
    <div class="player" style="width:100% !important; position: relative;" *ngIf="audioPath" > 
      <mat-advanced-audio-player [playlist]="playlist"[displayTitle]="false"
                    [displayPlaylist]="false">
      </mat-advanced-audio-player>
      
      
    </div>
    
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">Download</button>
    <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">Close</button>
  </div>
</div>
</div>
</div>
<!--END Audio Player-->

<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" style="z-index: 99999 !important;"
id="heartbeatLink" role="dialog" aria-labelledby="edit" aria-hidden="true">
<div class="modal-dialog">
<div class="modal-content" style="width:576px !important" >
  <div class="modal-header">
    <h5 class="modal-title">Send Heartbeat Link</h5>
    
    <button type="button" id="buttonEmergency" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
<div class="row">
  <div class="col-12">
    <label for="heartbeatLinkInput">Heartbeat Link:</label>
    <input type="text" id="heartbeatLinkInput" class="form-control" [(ngModel)]="heartbeatLink">
  </div>
</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-primary"  (click)="sendHeartbeatLink()">Send</button>
  </div>
</div>
</div>
</div>